<div class="wrapper">
  <h1 class="main-header">Datenschutzerklärung - BIMSWARM</h1>
  <div class="privacy-content">
    <div class="toc">
      <details>
        <summary>Inhaltsverzeichnis</summary>
        <nav class="toc__list" aria-label="Inhaltsverzeichnis">
          <a href="/privacy#Praaemble">1 Präambel</a>
          <a href="/privacy#Datenschutzerklaerung"
            >2 Wofür gilt diese Datenschutzerklärung?</a
          >
          <a href="/privacy#Verantwortlicher">3 Wer ist Verantwortlicher?</a>
          <a class="toc__indent-1" href="/privacy#Hauptansprechpartner">
            Hauptansprechpartner für Datenschutzanfragen
          </a>
          <!-- <br />
                <a
                    style="margin-left: 1em"
                    href="/privacy#Datenschutzbeauftragter"
                    >3.2 Datenschutzbeauftragter</a
                > -->
          <a href="/privacy#Datenverarbeitung"
            >4 Wie werden Ihre Daten verarbeitet</a
          >
          <a class="toc__indent-1" href="/privacy#Webseite"
            >4.1 Webseite https://www.bimswarm.de</a
          >
          <a class="toc__indent-2" href="/privacy#BesuchDerWebseite"
            >4.1.1 Besuch der Webseite</a
          >
          <a class="toc__indent-2" href="/privacy#Newsletter">
            4.1.2 Newsletter
          </a>

          <a class="toc__indent-1" href="/privacy#BIMSWARM-Marktplatz">
            4.2 BIMSWARM Plattform
          </a>

          <a class="toc__indent-2" href="/privacy#BesuchVomMarktplatz">
            4.2.1 Besuch der BIMSWARM Plattform
          </a>

          <a class="toc__indent-2" href="/privacy#Registrierung_Anmeldung">
            4.2.2 Registrierung, Anmeldung und Nutzer- bzw. Anbieterkonto
          </a>

          <a class="toc__indent-2" href="/privacy#Listung">
            4.2.3 Abonnement und Listung als Anbieter
          </a>

          <a class="toc__indent-2" href="/privacy#Zahlungsdienstleister">
            4.2.4 Verwendung von Zahlungsdienstleistern
          </a>

          <a class="toc__indent-2" href="/privacy#Demo">
            4.2.5 Demo anfragen
          </a>

          <a class="toc__indent-2" href="/privacy#Angebot">
            4.2.6 Angebot anfragen
          </a>

          <a class="toc__indent-2" href="/privacy#Produktbewertung">
            4.2.7 Produktbewertung und Merkzettelfunktion
          </a>

          <a class="toc__indent-2" href="/privacy#PlausibleAnalytics">
            4.2.8 Einfaches Anbieter-Reporting und Analysen mit Plausible
            Analytics
          </a>

          <a class="toc__indent-1" href="/privacy#Kontaktaufnahme">
            4.3 Kontaktaufnahme über E-Mail, Kontaktformular, Telefon oder per
            Post
          </a>

          <a class="toc__indent-1" href="/privacy#Social_Media">
            4.4 Social Media Präsenzen
          </a>

          <a class="toc__indent-1" href="/privacy#Cookies">
            4.5 Cookies und Tracking-Technologien
          </a>

          <a class="toc__indent-2" href="/privacy#AllgInfoCookies">
            4.5.1 Allgemeine Informationen zu Cookies
          </a>

          <a class="toc__indent-2" href="/privacy#DrittanbieterCookies">
            4.5.2 Cookies von Drittanbietern und Social-Media-Plugins
          </a>

          <a class="toc__indent-3" href="/privacy#Matomo">
            4.5.2.1 Einsatz von Matomo
          </a>

          <a class="toc__indent-3" href="/privacy#YouTube"> 4.5.2.2 YouTube </a>

          <a href="/privacy#Erhebung">
            5 Bei wem erheben wir Ihre personenbezogenen Daten?
          </a>

          <a href="/privacy#Weitergabe">
            6 An wen geben wir Ihre personenbezogenen Daten weiter?
          </a>

          <a class="toc__indent-2" href="/privacy#WeitergabePflichten">
            6.1 Weitergabe aufgrund gesetzlicher Pflichten oder zur Wahrung
            berechtigter Interessen
          </a>

          <a class="toc__indent-2" href="/privacy#VerbundeneUnternehmen">
            6.2 Verbundene Unternehmen und Produktanbieter
          </a>

          <a href="/privacy#Datenuebermittlung">
            7 Erfolgt eine Datenübermittlung an Drittländer?
          </a>

          <a href="/privacy#PersonenbezogeneDaten">
            8 Wie lange speichern wir Ihre personenbezogenen Daten?
          </a>

          <a href="/privacy#rechteNutzer">
            9 Welche Rechte haben Sie als betroffene Nutzer?
          </a>

          <a href="/privacy#Bereitstellung">
            10 Besteht eine Pflicht zur Bereitstellung personenbezogener Daten?
          </a>

          <a href="/privacy#Entscheidungsfindung">
            11 Findet eine automatisierte Entscheidungsfindung (einschließlich
            Profiling) statt?
          </a>

          <a href="/privacy#Schutzmassnahmen">
            12 Existieren technische Schutzmaßnahmen?
          </a>

          <a href="/privacy#Stand"> 13 Stand und Aktualisierung </a>
        </nav>
      </details>
    </div>
    <div>
      <ol>
        <li id="Praaemble">
          <h2>1 Präambel</h2>
          <p>
            Der BIMSWARM GmbH (&bdquo;<b>BIMSWARM</b>&ldquo;,
            &bdquo;<b>wir</b>&ldquo; oder &bdquo;<b>uns</b>&ldquo;) ist der
            Schutz Ihrer Privatsphäre und personenbezogenen Daten ein wichtiges
            Anliegen. Mit der folgenden Datenschutzerklärung informieren wir Sie
            umfassend über den Umgang mit Ihren personenbezogenen Daten und den
            Datenschutz bei BIMSWARM.
          </p>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Datenschutzerklaerung">
          <h2>2 Wofür gilt diese Datenschutzerklärung?</h2>
          <p>
            Diese Datenschutzerklärung findet Anwendung auf den Umgang mit Ihren
            personenbezogenen Daten, wenn Sie die BIMSWARM-Webseite unter
            <a href="https://www.bimswarm.de" target="_blank"
              >https://www.bimswarm.de</a
            >, die BIMSWARM Plattform unter
            <a href="https://www.bimswarm.online" target="_blank"
              >https://www.bimswarm.online</a
            >
            oder unser Social-Media-Profil auf LinkedIn und YouTube besuchen.
            Zudem gilt diese Datenschutzerklärung, wenn Sie mit uns über E-Mail,
            Telefon oder Post Kontakt aufnehmen.
          </p>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Verantwortlicher">
          <h2>3 Wer ist Verantwortlicher?</h2>

          <h3 id="Hauptansprechpartner">
            Hauptansprechpartner für Datenschutzanfragen
          </h3>
          <p>
            Der für die in dieser Datenschutzerklärung beschriebenen
            Datenverarbeitungen Verantwortliche ist:
          </p>

          <ul class="no-bullets">
            <li>BIMSWARM GmbH</li>
            <li>Geneststraße 5 / Aufgang A</li>
            <li>10829 Berlin</li>
            <li>Deutschland</li>
            <li>
              Tel.
              <a class="contact-link contact-link--phone">+49 30 92108778 0</a>
            </li>
            <li>
              E-Mail
              <a class="contact-link contact-link--email"
                >info&#64;bimswarm.de</a
              >
            </li>
          </ul>
          <p>
            Sie können sich hinsichtlich sämtlicher datenschutzrechtlichen
            Anliegen, insbesondere der Geltendmachung Ihrer Betroffenenrechte
            (Ziffer 9) jederzeit an den Verantwortlichen wenden. Hierfür steht
            Ihnen insbesondere die folgende E-Mail-Adresse bereit:
            <a href="mailto:contact@bimswarm.de" target="_blank"
              >datenschutz&#64;bimswarm.de</a
            >
          </p>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Datenverarbeitung">
          <h2>4 Wie werden Ihre Daten verarbeitet?</h2>

          <p>
            BIMSWARM erhebt und verarbeitet abhängig von der konkreten
            Verarbeitungssituation verschiedene personenbezogene Daten von
            Ihnen. Ihre personenbezogenen Daten verarbeiten wir ausschließlich
            im Einklang mit den Vorgaben der Datenschutz-Grundverordnung
            (“<b>DSGVO</b>“) und dem Bundesdatenschutzgesetz (“<b>BDSG</b>“).
            Nachfolgend finden Sie eine Auflistung, welche personenbezogenen
            Daten wir je nach Verarbeitungssituation verarbeiten, welchen
            Zwecken diese Datenverarbeitungen dienen und auf welcher
            Rechtsgrundlage wir die Daten verarbeiten.
          </p>
          <ul>
            <ol>
              <li id="Webseite" class="section level-2">
                <h3>
                  4.1 Webseite
                  <a href="https://www.bimswarm.de" target="_blank_"
                    >https://www.bimswarm.de</a
                  >
                </h3>
                <p>
                  In diesem Abschnitt 4.1 beschreiben wir, wie Ihre
                  personenbezogenen Daten im Zusammenhang mit dem Besuch der
                  BIMSWARM-Website unter:
                  <a href="https://www.bimswarm.de">https://www.bimswarm.de</a>
                  verarbeitet werden.
                </p>
              </li>

              <ol>
                <li id="BesuchDerWebseite" class="section level-3">
                  <div class="sub-header sub-header--tight">
                    4.1.1 Besuch der Webseite
                  </div>

                  <table class="privacy-table">
                    <tr>
                      <th class="privacy-table__heading">
                        (a) Kategorien personenbezogener Daten
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Der Besuch unserer Webseite ist grundsätzlich ohne
                        Offenlegung Ihrer Identität möglich. Allerdings
                        verarbeiten wir bei dem Aufruf unserer Webseite
                        insbesondere die folgenden personenbezogenen Daten:
                        <p>
                          • Protokolldaten, d.h. Daten in Bezug auf die Nutzung
                          der bereitgestellten Webseite (z.B. verwendeter
                          Webbrowser und Betriebssystem, Referrer-URL, Datum und
                          Uhrzeit des Aufrufs, übertragene Datenmenge),
                        </p>
                        <p>• IP-Adresse des anfragenden Rechners, sowie</p>
                        <p>
                          • weitere technische Daten, die mit den
                          vorangegangenen vergleichbar sind.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">
                        (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Die Verarbeitung der Daten dient dazu Ihnen den Besuch
                        unserer Webseite zu ermöglichen und unsere Webseite
                        ordnungsgemäß anzeigen zu können. Daneben dient die
                        Verarbeitung statistischen Zwecken und der Verbesserung
                        der Qualität unserer Webseite, insbesondere der
                        Stabilität und der Sicherheit der Verbindung.
                        Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">(c) Speicherdauer</th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Die Daten werden nach 30 Tagen gelöscht, sofern keine
                        längere gesetzliche Frist zur weiteren Speicherung
                        eingreift.
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">(d) Empfänger</th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        <p>
                          Unsere Webseite wird bei einem externen Dienstleister
                          (Mittwald) gehostet, der im Rahmen einer (Unter-)
                          Auftragsverarbeitung zur Erbringung von Hosting- und
                          Supportleistungen auf die im folgenden aufgeführten
                          Daten ggf. Zugriff nehmen muss.
                        </p>
                        <p>
                          Unsere Website wird bei der Mittwald CM Service GmbH &
                          Co. KG, Königsberger Straße 4–6, 32339 Espelkamp
                          („Mittwald“), gehostet. Wenn Sie unsere Website
                          besuchen, erfasst Mittwald verschiedene Log-Daten, wie
                          z. B.:
                        </p>
                        <p>• IP-Adresse</p>
                        <p>• Datum und Uhrzeit der Anfrage</p>
                        <p>• URL und Pfad der angefragten Seite</p>
                        <p>• Übertragene Datenmenge</p>
                        <p>• Herkunftswebsite (Referrer)</p>
                        <p>• Browsertyp, Version und Betriebssystem</p>

                        <p>
                          Diese Daten werden automatisiert erhoben und dienen
                          dem sicheren und zuverlässigen Betrieb der Website
                        </p>
                        <p>
                          Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs.
                          1 lit. f DSGVO (berechtigtes Interesse am sicheren und
                          effizienten Bereitstellen unseres Onlineangebots).
                        </p>
                        <p>
                          Wir haben mit Mittwald einen Vertrag zur
                          Auftragsverarbeitung (AVV) gemäß Art. 28 DSGVO
                          abgeschlossen.
                        </p>
                        <p>
                          Weitere Informationen finden Sie in der
                          Datenschutzerklärung von Mittwald:
                        </p>
                        <p>
                          <a
                            href="https://www.mittwald.de/datenschutz"
                            target="_blank"
                          >
                            https://www.mittwald.de/datenschutz
                          </a>
                        </p>
                      </th>
                    </tr>
                  </table>
                </li>

                <li id="Newsletter" class="section level-3">
                  <div class="sub-header sub-header--tight">
                    4.1.2 Newsletter
                  </div>
                  <p>
                    Sie können sich auf unserer Webseite für unseren Newsletter
                    anmelden.
                  </p>

                  <table class="privacy-table">
                    <tr>
                      <th class="privacy-table__heading">
                        (a) Kategorien personenbezogener Daten
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Wenn Sie sich für unseren Newsletter anmelden,
                        verarbeiten wir von Ihnen:
                        <p>• E-Mail-Adresse,</p>
                        <p>• Vorname und Nachname,</p>
                        <p>
                          • Referrer-URL, Datum und Uhrzeit der Anmeldung und
                          des Aufrufs, Webbrowser,
                        </p>
                        <p>• IP-Adresse, sowie</p>
                        <p>
                          • Informationen zwecks Nachweises der
                          Newsletter-Anmeldung.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">
                        (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        <p>
                          Die Verarbeitung der Daten dient ausschließlich dazu,
                          Ihnen Informationen zu unseren Leistungen und uns zu
                          übersenden sowie Sie über neue Leistungen und
                          Entwicklungen von BIMSWARM auf dem Laufenden zu
                          halten. Rechtsgrundlage ist Ihre Einwilligung nach
                          Art. 6 Abs. 1 S. 1 lit. a DSGVO. Eine Einwilligung ist
                          stets freiwillig. Die Verweigerung der Einwilligung
                          oder ein Widerruf derselben hat keine negativen
                          Auswirkungen auf Sie.
                        </p>

                        <p>
                          Für die Anmeldung zu unserem Newsletter verwenden wir
                          das sog. Double-Opt-In-Verfahren. Das heißt, dass wir
                          Ihnen nach Ihrer Anmeldung eine E-Mail an die
                          angegebene E-Mail-Adresse senden, in welcher wir Sie
                          um Bestätigung bitten, dass Sie den Versand des
                          Newsletters wünschen. Zweck dieses Verfahrens ist,
                          Ihre Anmeldung nachweisen und ggf. einen möglichen
                          Missbrauch Ihrer persönlichen Daten aufklären zu
                          können.
                        </p>
                        <p>
                          Ihre Einwilligung in die Übersendung des Newsletters
                          können Sie jederzeit widerrufen und den Newsletter
                          abbestellen. Den Widerruf können Sie durch Klick auf
                          den in jeder Newsletter-E-Mail bereitgestellten Link,
                          per E-Mail an contact&#64;bimswarm.de oder durch eine
                          Nachricht an die im Impressum angegebenen Kontaktdaten
                          erklären.
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">(c) Speicherdauer</th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Die Daten werden nach Abmeldung vom Newsletter gelöscht,
                        sofern keine längere gesetzliche Frist zur weiteren
                        Speicherung eingreift.
                      </th>
                    </tr>
                    <tr>
                      <th class="privacy-table__heading">(d) Empfänger</th>
                    </tr>
                    <tr>
                      <th class="privacy-table__cell">
                        Für den Versand unseres Newsletters nutzen wir das
                        Newsletter-Tool LUX innerhalb unseres
                        Content-Management-Systems TYPO3.
                      </th>
                    </tr>
                  </table>
                </li>
              </ol>

              <!-- ---------------------------------------------------------------------------------------------------------------------------------------------------------------- -->
              <li id="BIMSWARM-Marktplatz" class="section level-2">
                <h3>
                  4.2 BIMSWARM Plattform (<a
                    href="https://www.bimswarm.online"
                    target="_blank"
                    >bimswarm.online</a
                  >)
                </h3>

                <p>
                  In diesem Abschnitt 4.2 beschreiben wir, wie Ihre
                  personenbezogenen Daten im Zusammenhang mit dem Besuch der
                  BIMSWARM Plattform unter:
                  <a href="https://www.bimswarm.online" target="_blank"
                    >https://www.bimswarm.online
                  </a>
                </p>
                <p>
                  BIMSWARM bietet Anbietern von BIM und Bau-IT-Produkten eine
                  Plattform zur Präsentation und zum Angebot ihrer BIM und
                  Bau-IT-Produkte. Über die BIMSWARM Plattform können sich
                  Nutzer über aktuelle Informationen und Angebote aus dem
                  Bausoftwaremarkt informieren. Die BIMSWARM Plattform ist eine
                  neutrale Plattform für die zielgerichtete Recherche von
                  Bau-IT-Produkten sowie Informationen zu offenen Standards und
                  Qualitätskriterien.
                </p>
                <ol>
                  <li id="BesuchVomMarktplatz" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.1 Besuch der BIMSWARM Plattform
                    </div>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Der Besuch unserer Plattform ist grundsätzlich ohne
                          Offenlegung Ihrer Identität möglich. Allerdings
                          verarbeiten wir bei dem Aufruf der Plattform
                          insbesondere die folgenden personenbezogenen Daten:
                          <p>
                            • Protokolldaten, d.h. Daten in Bezug auf die
                            Nutzung der bereitgestellten Webseite (z.B.
                            verwendeter Webbrowser und Betriebssystem,
                            Referrer-URL, Datum und Uhrzeit des Aufrufs,
                            übertragene Datenmenge),
                          </p>
                          <p>• IP-Adresse des anfragenden Rechners, sowie</p>
                          <p>
                            • weitere technische Daten, die mit den
                            vorangegangenen vergleichbar sind.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient dazu Ihnen den
                            Besuch der Plattform zu ermöglichen und diese
                            ordnungsgemäß anzeigen zu können. Daneben dient die
                            Verarbeitung statistischen Zwecken und der
                            Verbesserung der Qualität unserer Plattform,
                            insbesondere der Stabilität und der Sicherheit der
                            Verbindung. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1
                            lit. f DSGVO.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Die Daten werden nach 30 Tagen gelöscht, sofern keine
                          längere gesetzliche Frist zur weiteren Speicherung
                          eingreift.
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">(d) Empfänger</th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <!-- In 4.2.2 / 4.2.3 we use Amazon Web Services (AWS) instead of Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, 1855 Luxemburg -->
                          Unsere Plattform wird bei einem externen Dienstleister
                          (Amazon Web Services EMEA SARL, 38 Avenue John F.
                          Kennedy, 1855 Luxemburg) gehostet, der im Rahmen einer
                          (Unter-) Auftragsverarbeitung zur Erbringung von
                          Hosting- und Supportleistungen auf die vorstehend
                          aufgeführten Daten ggf. Zugriff nehmen muss. AWS
                          verarbeitet Ihre personenbezogenen Daten in unserem
                          Auftrag und auf unsere Weisung. Details dazu finden
                          Sie unter:
                          <a
                            href="https://aws.amazon.com/de/compliance/germany-data-protection/"
                            target="_blank"
                            >https://aws.amazon.com/de/compliance/germany-data-protection/</a
                          >.
                        </th>
                      </tr>
                    </table>
                  </li>

                  <li id="Registrierung_Anmeldung" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.2 Registrierung, Anmeldung und Nutzer- bzw.
                      Anbieterkonto
                    </div>

                    <p>
                      Sie können sich auf der BIMSWARM Plattform als Anbieter
                      und Nutzer registrieren und ein entsprechendes Konto
                      anlegen. Ein Nutzerkonto ermöglicht es Ihnen Produkte auf
                      der BIMSWARM Plattform zu bewerten und Produkte auf einem
                      Merkzettel zu speichern. Ein Anbieterkonto ermöglicht es
                      Ihnen BIM und Bau-IT-Produkten auf der Plattform zu
                      präsentieren und anzubieten. Für die Konten bieten wir aus
                      Gründen der Benutzerfreundlichkeit ein sog. Single-Sign-On
                      Verfahren an. Dies umfasst das Einrichten einer „Sitzung“
                      zwischen dem Client und Server, welche Ihnen die Bewegung
                      in der gesamten Plattform ermöglicht, ohne dass Sie sich
                      für jeden Bereich erneut anmelden müssen. Diese Sitzung
                      wird dabei durch ein Cookie dargestellt (siehe Ziffer
                      4.5). Überdies speichern wir in einem weiteren Cookie die
                      Ihnen zugeordneten Login-Informationen (Benutzername,
                      Benutzerrechte und die Gültigkeit der Sitzung) zur
                      Zugriffssteuerung. Anstatt Sie zur erneuten Eingabe Ihrer
                      Anmeldeinformationen aufzufordern, wird das Cookie an den
                      Server gesendet und als Identitätsbeweis akzeptiert.
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Wenn Sie ein Nutzer- bzw. Anbieterkonto anlegen,
                          verarbeiten wir von Ihnen:
                          <p>• E-Mail-Adresse,</p>
                          <p>
                            • weitere im Rahmen der Registrierung freiwillig
                            angegebene Informationen,
                          </p>
                          <p>• Passwort-Hash,</p>
                          <p>
                            • Referrer-URL, Datum und Uhrzeit des Aufrufs und
                            der Anmeldung, Webbrowser,
                          </p>
                          <p>• IP-Adresse, sowie</p>
                          <p>
                            • Informationen zwecks Nachweises der Registrierung.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient ausschließlich dazu
                            Ihnen ein Nutzerkonto auf der Plattform
                            bereitzustellen und Ihnen die damit verbundenen
                            Funktionen anzubieten. Rechtsgrundlage ist Art. 6
                            Abs. 1 S. 1 lit. b DSGVO.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Grundsätzlich werden Ihre Daten für die Dauer Ihrer
                            Registrierung gespeichert. Wenn Sie von Ihrem
                            Widerspruchsrecht Gebrauch machen wollen und/oder
                            die Löschung Ihres Nutzerkontos oder einzelner
                            Datensätze wünschen, können Sie uns eine E-Mail an
                            datenschutz&#64;bimswarm.de senden. Wir veranlassen
                            dann unverzüglich die Löschung Ihres Nutzerkontos
                            oder der betreffenden Datensätze. Mit Löschung Ihres
                            Nutzerkontos werden all Ihre Profildaten und damit
                            verknüpften Informationen vollständig gelöscht,
                            sofern keine längere gesetzliche Frist zur weiteren
                            Speicherung eingreift.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">(d) Empfänger</th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Unsere Plattform wird bei Amazon Web Services (AWS)
                            gehostet, der im Rahmen einer (Unter-)
                            Auftragsverarbeitung zur Erbringung von Hosting- und
                            Supportleistungen auf die vorstehend aufgeführten
                            Daten ggf. Zugriff nehmen muss.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <li id="Listung" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.3 Abonnement und Listung als Anbieter
                    </div>

                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Um BIM und Bau-IT-Produkte auf der Plattform
                          präsentieren und anbieten zu können, müssen Sie über
                          Ihr Anbieterkonto ein Abonnement abschließen. Wenn Sie
                          als Anbieter ein Abonnement abschließen und Produkte
                          auf die Plattform stellen, verarbeiten wir von Ihnen:
                          <p>• E-Mail-Adresse,</p>
                          <p>• Vorname und Nachname,</p>
                          <p>• Informationen zum Produkt und Abo-Modell,</p>
                          <p>
                            • Zahlungsinformationen wie Kreditkartennummer oder
                            andere Bankinformationen,
                          </p>
                          <p>
                            • Referrer-URL, Datum und Uhrzeit des Aufrufs und
                            der Anfrage, Webbrowser,
                          </p>
                          <p>• IP-Adresse, sowie</p>
                          <p>
                            • weitere im Rahmen der Anfrage freiwillig
                            angegebene Informationen.
                          </p>
                          <p>
                            Die Abwicklung der Bezahlung des Abonnements erfolgt
                            über den Zahlungsdienstleister Stripe (Ziffer
                            4.2.4).
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient ausschließlich
                            dazu, das Vertragsverhältnis mit Ihnen abzuwickeln
                            und Ihnen die Präsentation und das Angebot Ihrer
                            Produkte auf der Plattform zu ermöglichen.
                            Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Ihre Daten werden für die Dauer des
                            Vertragsverhältnisses gespeichert, sofern keine
                            längeren gesetzlichen Aufbewahrungspflichten
                            eingreifen. Wenn Sie von Ihrem Widerspruchsrecht
                            Gebrauch machen wollen und/oder die Löschung Ihres
                            Produkts oder einzelner Datensätze wünschen, können
                            Sie die Löschung Ihrer Produktlistung auf der
                            Plattform oder der betreffenden Datensätze selbst
                            vornehmen. Mit Löschung Ihrer Listung werden all
                            Ihre Profildaten und damit verknüpften Informationen
                            vollständig gelöscht, sofern keine längere
                            gesetzliche Frist zur weiteren Speicherung
                            eingreift.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">(d) Empfänger</th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Unsere Plattform wird bei Amazon Web Services (AWS)
                            gehostet, der im Rahmen einer (Unter-)
                            Auftragsverarbeitung zur Erbringung von Hosting- und
                            Supportleistungen auf die vorstehend aufgeführten
                            Daten ggf. Zugriff nehmen muss.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <!-- ---------------------------------------------------------------------------------------------------------------------------------->

                  <li id="Zahlungsdienstleister" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.4 Verwendung von Zahlungsdienstleistern
                    </div>
                    <p>
                      Die Abwicklung der Bezahlung Ihres Abonnements erfolgt
                      über den Zahlungsdienst Stripe. Die Einbindung von Stripe
                      bietet Ihnen die Möglichkeit, mit Kreditkarte zu bezahlen.
                      Im Rahmen der
                      <b>Buchung eines Abos</b>, werden die von Ihnen
                      mitgeteilten und für die Abwicklung der Bezahlung
                      erforderlichen Zahlungsinformationen an Stripe
                      übermittelt.
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Im Rahmen der Buchung verarbeitet der angebundene
                          Zahlungsdienstleister folgende personenbezogene Daten:
                          <p>• Anrede, Vor- und Nachname,</p>
                          <p>• E-Mail-Adresse,</p>
                          <p>
                            • Datum und Uhrzeit des Aufrufs und der Anmeldung
                            und Zeitzone,
                          </p>
                          <p>
                            • Geräteinformationen wie die IP-Adresse, Geräte-ID,
                            Geräteart, gerätespezifische Einstellungen,
                          </p>
                          <p>
                            • Browserart und Betriebssystem des Endgeräts sowie
                          </p>
                          <p>
                            • Zahlungsinformationen wie Kreditkartennummer oder
                            andere Bankinformationen, Zahlungsbetrag und weitere
                            erforderliche Transaktionsdaten.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die im Rahmen der Buchung durch den Zahlungsanbieter
                            verarbeiteten personenbezogenen Daten werden
                            ausschließlich zur Erfüllung der Buchung, d.h. der
                            Abwicklung der Zahlung, verwendet. Die Weitergabe
                            Ihrer Daten erfolgt daher ebenfalls ausschließlich
                            zum Zwecke der Zahlungsabwicklung und nur insoweit,
                            als sie hierfür erforderlich ist. Nach erfolgreicher
                            Zahlung erhalten wir eine entsprechende Bestätigung.
                          </p>
                          <p>
                            <b
                              >Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b
                              DSGVO.</b
                            >
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Weitere Informationen zum Zahlungsdienstleister
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Anbieter des Dienstes ist die
                          <p>
                            • Stripe Payments Europe Ltd., 1 Grand Canal Street
                            Lower, Grand Canal Dock, Dublin, Irland.
                          </p>
                          <p>
                            Weitere Informationen dazu, wie Stripe Ihre Daten
                            verarbeitet, an welche weiteren Stellen
                            personenbezogene Daten möglicherweise weitergegeben
                            werden, ob Stripe Ihre Daten in die USA übermittelt
                            und welche Schutzmaßnahmen Stripe zur Gewährleistung
                            eines angemessenen Datenschutzniveaus umsetzt,
                            finden Sie in der Datenschutzerklärung (<a
                              href="https://stripe.com/en-de/privacy"
                            >
                              https://stripe.com/en-de/privacy</a
                            >) von Stripe. Stripe ist unter dem EU-U.S. Data
                            Privacy Framework zertifiziert.
                          </p>
                          <p>
                            Stripe handelt nach eigenen Angaben je nach
                            Aktivität als „Datenverantwortlicher“ und/oder
                            „Auftragsverarbeiter“. Informationen hierzu finden
                            Sie unter:
                            <a
                              href="https://stripe.com/de/legal/privacy-center#data-transfers"
                            >
                              https://stripe.com/de/legal/privacy-center#data-transfers</a
                            >. Wir haben mit Stripe in Bezug auf die
                            Auftragsverarbeitung ein Data Processing Agreement
                            abgeschlossen.
                          </p>
                          <p>
                            Bitte beachten Sie, dass der Zahlungsdienstleister
                            Ihre Daten jedoch auch für eigene Zwecke verarbeitet
                            (z.B. Betrugserkennung und -abwehr, Gewährleistung
                            der Netzwerk- und Informationssicherheit,
                            Performance-/ Dienstanalysen). Hierauf haben wir
                            keinen Einfluss. Wir empfehlen Ihnen, die
                            Datenschutzhinweise der jeweiligen Anbieter zu
                            lesen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (d) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Grundsätzlich werden Ihre Zahlungsinformationen von
                            uns für die Dauer Ihrer Registrierung in Ihrem
                            Nutzerkonto gespeichert. Wenn Sie von Ihrem
                            Widerspruchsrecht Gebrauch machen wollen und/oder
                            die Löschung Ihres Nutzerkontos oder einzelner
                            Datensätze wünschen, können Sie die Löschung Ihres
                            Nutzerkontos selbst durchführen. Die Löschung wird
                            dann unmittelbar ausgeführt.
                          </p>
                          <p>
                            Mit Löschung Ihres Nutzerkontos werden all Ihre
                            Profildaten und damit verknüpften Informationen
                            vollständig gelöscht, sofern keine längere
                            gesetzliche Frist zur weiteren Speicherung
                            eingreift.
                          </p>
                          <p>
                            Bitte beachten Sie, dass wir auf die Erhebung und
                            Verarbeitung Ihrer Daten durch Stripe keinen
                            Einfluss haben, sie erfolgt vielmehr ausschließlich
                            durch den Zahlungsdienstleister. Dementsprechend
                            sind wir für diese Erhebung und Verarbeitung nicht
                            verantwortlich; die Verantwortung dafür liegt allein
                            bei Stripe und wir haben daher auch keinen Einfluss
                            auf die Speicherdauer durch Stripe.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <!-- -------------------------------------------------------------------------------------------------------------------------------->

                  <li id="Demo" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.5 Demo anfrage
                    </div>
                    <p>
                      Als Nutzer können Sie eine Demo für ein Produkt auf der
                      BIMSWARM Plattform anfragen. Dadurch haben Sie die
                      Möglichkeit die Produkte auf der Plattform kennenzulernen.
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Wenn Sie eine Demo-Version anfragen, verarbeiten wir
                          von Ihnen:
                          <p>• E-Mail-Adresse,</p>
                          <p>• Vorname und Nachname,</p>
                          <p>• Inhalt der Anfrage,</p>
                          <p>
                            • Referrer-URL, Datum und Uhrzeit des Aufrufs und
                            der Anfrage, Webbrowser,
                          </p>
                          <p>• IP-Adresse, sowie</p>
                          <p>
                            • weitere im Rahmen der Anfrage freiwillig
                            angegebene Informationen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient ausschließlich dazu
                            Ihre Anfrage zu bearbeiten und Ihnen eine
                            Demo-Version des Produktes zur Verfügung zu stellen.
                            Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Daten werden nach Bearbeitung Ihrer Anfrage
                            gelöscht, sofern keine längere gesetzliche Frist zur
                            weiteren Speicherung eingreift.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <!-- -------------------------------------------------------------------------------------------------------------------------------->

                  <li id="Angebot" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.6 Angebot anfragen
                    </div>
                    <p>
                      Als Nutzer können Sie ein Angebot für ein spezifisches
                      Produkt auf der BIMSWARM Plattform anfragen. Dadurch haben
                      Sie die Möglichkeit das Produkt zu erwerben.
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Wenn Sie ein Angebot für ein spezifisches Produkt
                          anfragen, verarbeiten wir von Ihnen:
                          <p>• E-Mail-Adresse,</p>
                          <p>• Vorname und Nachname,</p>
                          <p>• Inhalt der Anfrage,</p>
                          <p>
                            • Referrer-URL, Datum und Uhrzeit des Aufrufs und
                            der Anfrage, Webbrowser,
                          </p>
                          <p>• IP-Adresse, sowie</p>
                          <p>
                            • weitere im Rahmen der Anfrage freiwillig
                            angegebene Informationen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient ausschließlich dazu
                            Ihre Anfrage zu bearbeiten und Ihnen ein Angebot für
                            ein Produkt zu erstellen. Rechtsgrundlage ist Art. 6
                            Abs. 1 S. 1 lit. b DSGVO.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Daten werden nach Bearbeitung Ihrer Anfrage
                            gelöscht, sofern keine längere gesetzliche Frist zur
                            weiteren Speicherung eingreift.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <!-- -------------------------------------------------------------------------------------------------------------------------------->

                  <li id="Produktbewertung" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.7 Produktbewertung und Merkzettelfunktion
                    </div>

                    <p>
                      Registrierte Nutzer haben auf den Produktseiten der
                      Plattform die Möglichkeit, Produkte zu bewerten und
                      Produkte für sich auf einem Merkzettel zu speichern. Diese
                      Funktionen sind freiwillig, d.h. Sie sind nicht
                      verpflichtet Bewertungen abzugeben. Die Bewertung erfolgt
                      ausschließlich über die Angabe von Sternen (zwischen 1 und
                      5 Sterne).
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          Wenn Sie eine Produktbewertung abgeben, erfassen wir
                          die folgenden personenbezogenen Daten, die Sie
                          freiwillig eingeben:
                          <p>• Rating (Bewertung zwischen 1 und 5 Sternen),</p>
                          <p>
                            • Protokolldaten, d.h. Daten in Bezug auf die
                            Nutzung der bereitgestellten Webseite (z.B.
                            verwendeter Webbrowser und Betriebssystem,
                            Referrer-URL, Datum und Uhrzeit des Aufrufs,
                            übertragene Datenmenge),
                          </p>
                          <p>
                            • IP-Adresse des anfragenden Rechners und
                            Nutzerkonto-ID, sowie
                          </p>
                          <p>
                            • weitere technische Daten, die mit den
                            vorangegangenen vergleichbar sind.
                          </p>
                          Wenn Sie ein Produkt auf dem Merkzettel speichern,
                          erfassen wir die folgenden personenbezogenen Daten,
                          die Sie freiwillig eingeben:
                          <p>
                            • Protokolldaten, d.h. Daten in Bezug auf die
                            Nutzung der bereitgestellten Webseite (z.B.
                            verwendeter Webbrowser und Betriebssystem,
                            Referrer-URL, Datum und Uhrzeit des Aufrufs,
                            übertragene Datenmenge),
                          </p>
                          <p>
                            • IP-Adresse des anfragenden Rechners und
                            Nutzerkonto-ID, sowie
                          </p>
                          <p>
                            • weitere technische Daten, die mit den
                            vorangegangenen vergleichbar sind.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung der Daten dient dazu
                            Produktbewertungen auf der Plattform anzuzeigen bzw.
                            Ihnen zu ermöglichen sich bestimmte Produkte zu
                            merken und diese wieder zu finden. Daneben dient die
                            Verarbeitung statistischen Zwecken und der
                            Verbesserung der Qualität unserer Plattform.
                            Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
                            Wir haben ein berechtigtes Interesse an den
                            Bewertungen der Produkte auf der Plattform sowie
                            daran Ihnen das Wiederauffinden von Produkten zu
                            vereinfachen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Bewertungsdaten werden solange gespeichert, wie
                            das betreffende Produkt gelistet ist. Die
                            Merkzetteldaten werden solange gespeichert, wie Sie
                            das Produkt auf Ihrem Merkzettel speichern. Sie
                            können den Merkzettel jederzeit löschen. Wenn Sie
                            von Ihrem Widerspruchsrecht Gebrauch machen wollen
                            und/oder die Löschung Ihrer Bewertung oder einzelner
                            Datensätze wünschen, können Sie uns eine E-Mail an
                            datenschutz&#64;bimswarm.de senden. Wir veranlassen
                            dann unverzüglich die Löschung Ihrer Bewertung oder
                            der betreffenden Datensätze. Mit Löschung Ihrer
                            Bewertung werden damit verknüpfte Informationen
                            vollständig gelöscht, sofern keine längere
                            gesetzliche Frist zur weiteren Speicherung
                            eingreift.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>

                  <!-- -------------------------------------------------------------------------------------------------------------------------------->

                  <li id="PlausibleAnalytics" class="section level-3">
                    <div class="sub-header sub-header--tight">
                      4.2.8 Einfaches Anbieter-Reporting und Analysen mit
                      Plausible Analytics
                    </div>

                    <p>
                      Wir bieten Anbietern auf der BIMSWARM Plattform ein
                      sogenanntes "einfaches Reporting" an, um Informationen
                      über das Interesse an deren Produkten zu analysieren und
                      darzustellen. Dieses Reporting erfolgt vollständig
                      anonymisiert und lässt keine Rückschlüsse auf einzelne
                      Nutzer zu. Wir nutzen für das Reporting und die Analyse
                      das Tool Plausible Analytics des Anbieters Plausible
                      Insights OÜ, Västriku tn 2, 50403, Tartu, Estland.
                    </p>
                    <p>
                      Cookies werden laut Plausible nicht gesetzt und ein
                      Rückschluss auf Personen ist daher nicht möglich. Das
                      Datenschutzrecht ist daher nicht einschlägig. Dennoch
                      möchten wir Sie über das Reporting und die Analysen
                      informieren. Kategorien verarbeiteter Daten
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__cell">
                          Im Rahmen des Reportings werden ausschließlich
                          aggregierte Nutzungsdaten erfasst:
                          <p>
                            • Aktivierte Filter, über die das Produkt gefunden
                            wurde (z. B. Anzahl Treffer bei AVA, IFC etc.)
                          </p>
                          <p>
                            • Begriffe aus der Freitextsuche, über die ein
                            Produkt gefunden wurde
                          </p>
                          <p>
                            • Herkunft der Nutzer (Referrer), z. B. Google,
                            LinkedIn, ChatGPT, Verbandswebseiten
                          </p>
                          <p>• Anzahl der Seitenaufrufe pro Produktseite</p>
                          <p>
                            • [zukünftig] Verweildauer auf der Produktseite
                            (z. B. als Boxplot)
                          </p>
                          <p>• [zukünftig] Scrolltiefe auf der Produktseite</p>
                          <p>
                            • [zukünftig] Anzahl Klicks auf "Angebot anfordern"
                            und "Demo anfordern"
                          </p>
                          <p>
                            IP-Adressen werden nicht gespeichert; eine
                            Individualisierung findet nicht statt.
                          </p>
                          <p>Zweck der Verarbeitung</p>
                          <p>
                            • Reichweitenmessung, Fehleranalyse und Optimierung
                            unseres Online-Angebots
                          </p>
                          <p>
                            Es erfolgt ausdrücklich keine personenbezogene
                            Analyse oder Profilbildung. Das Reporting ist rein
                            statistischer Natur. Weitere Informationen finden
                            Sie unter:
                            <a
                              href="https://plausible.io/data-policy"
                              target="_blank"
                              >https://plausible.io/data-policy</a
                            >
                            sowie
                            <a href="https://plausible.io/privacy"
                              >https://plausible.io/privacy</a
                            >.
                          </p>
                        </th>
                      </tr>
                    </table>
                  </li>
                </ol>
              </li>

              <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------->

              <li id="Kontaktaufnahme" class="section level-2">
                <h3>
                  4.3 Kontaktaufnahme über E-Mail, Kontaktformular, Telefon oder
                  per Post
                </h3>
                <table class="privacy-table">
                  <tr>
                    <th class="privacy-table__heading">
                      (a) Kategorien personenbezogener Daten
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      Bei der Kontaktaufnahme verarbeiten wir insbesondere die
                      folgenden personenbezogenen Daten:
                      <p>• E-Mail-Adresse,</p>
                      <p>• Telefonnummer,</p>
                      <p>• Adresse,</p>
                      <p>• Vorname und Nachname,</p>
                      <p>• Zeitpunkt der Anfrage,</p>
                      <p>
                        • Informationen, die Sie im Rahmen der Kontaktaufnahme
                        zur Verfügung stellen.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (b) Zwecke und Rechtsgrundlage der Datenverarbeitung
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Die Verarbeitung der Daten dient ausschließlich dazu
                        Ihre Anfrage zu bearbeiten. Rechtsgrundlage ist Art. 6
                        Abs. 1 S. 1 lit. b DSGVO.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">(c) Speicherdauer</th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Die Daten werden nach zufriedenstellender Beantwortung
                        Ihrer Anfrage gelöscht, sofern keine längere gesetzliche
                        Frist zur weiteren Speicherung eingreift.
                      </p>
                    </th>
                  </tr>
                </table>
              </li>

              <!-- ------------------------------------------------------------------------------------------------------------>

              <li id="Social_Media" class="section level-2">
                <h3>4.4 Social Media Präsenzen</h3>
                <p>
                  Wir unterhalten in verschiedenen sozialen Netzwerken
                  öffentlich zugängliche Profile, um über aktuelle Entwicklungen
                  unseres Unternehmens zu berichten und mit Kunden und weiteren
                  Interessenten in Kontakt treten zu können. Aktuell sind wir
                  auf folgenden Social-Media-Plattformen präsent:
                </p>
                <p>
                  • YouTube:
                  <a
                    href="https://www.youtube.com/@bimswarm4335"
                    target="_blank"
                    >https://www.youtube.com/@bimswarm4335</a
                  >
                </p>
                <p>
                  • LinkedIn:
                  <a
                    href="https://de.linkedin.com/company/bimswarm?trk=public_post_feed-actor-name"
                    target="_blank"
                    >https://de.linkedin.com/company/bimswarm?trk=public_post_feed-actor-name</a
                  >
                </p>
                <p>
                  Ihr Besuch dieser Profile setzt eine Vielzahl von
                  Datenverarbeitungsvorgängen in Gang. Nachfolgend geben wir
                  Ihnen einen Überblick darüber, welche Ihrer personenbezogenen
                  Daten von uns erhoben, genutzt und gespeichert werden, wenn
                  Sie unsere Profile besuchen.
                </p>
                <p>
                  Bei Ihrem Besuch unserer Profile werden Ihre personenbezogenen
                  Daten nicht nur durch uns, sondern auch durch die Betreiber
                  des jeweiligen sozialen Netzwerks („<b>Anbieter</b>“) erhoben,
                  genutzt und gespeichert. Dies geschieht auch dann, wenn Sie
                  selbst kein Profil in dem jeweiligen sozialen Netzwerk haben.
                  Die einzelnen Datenverarbeitungsvorgänge und ihr Umfang
                  unterscheiden sich je nach Anbieter und sie sind nicht
                  zwingend für uns nachvollziehbar. Einzelheiten über die
                  Erhebung und Speicherung Ihrer persönlichen Daten sowie über
                  Art, Umfang und Zweck ihrer Verwendung durch den Anbieter
                  entnehmen Sie bitte den Datenschutzerklärungen des jeweiligen
                  Anbieters:
                </p>
                <p>
                  • die Datenschutzerklärung für <b>YouTube</b>, das von Google
                  Ireland Limited, Gordon House, Barrow Street, Dublin 4,
                  Irland, betrieben wird, können Sie unter
                  <a
                    href="https://policies.google.com/privacy?hl=de&gl=de#intro"
                    target="_blank"
                    >https://policies.google.com/privacy?hl=de&gl=de#intro</a
                  >
                  einsehen.
                </p>
                <p>
                  • die Datenschutzerklärung für LinkedIn, das von LinkedIn
                  Ireland Unlimited Company, Wilton Place, Dublin 2, Irland
                  betrieben wird, können Sie unter:
                  <a
                    href="http://www.linkedin.com/legal/privacy-policy"
                    target="_blank"
                    >http://www.linkedin.com/legal/privacy-policy</a
                  >
                  einsehen.
                </p>
                <p>
                  Als Betreiber einer Social Media Präsenz können wir nur die in
                  Ihrem öffentlichen Profil hinterlegten Informationen einsehen,
                  und dies auch nur, sofern Sie über ein solches Profil verfügen
                  und in dieses eingeloggt sind, während Sie unsere Seite
                  aufrufen. Zusätzlich stellen uns LinkedIn anonyme
                  Nutzungsstatistiken zur Verfügung, die wir zur Verbesserung
                  des Nutzererlebnisses beim Besuch unserer Seiten verwenden.
                </p>

                <p>
                  Wir haben keinen Zugriff auf die Nutzungsdaten, die LinkedIn
                  zur Erstellung dieser Statistiken erhebt. Dennoch besteht
                  zwischen uns und LinkedIn, welche derartige
                  Nutzungsstatistiken erstellt in Bezug auf die dabei
                  stattfindenden Datenverarbeitungsvorgänge eine gemeinsame
                  Verantwortlichkeit nach Art. 26 DSGVO. Als „gemeinsam
                  Verantwortliche“ sind wir gemeinschaftlich für die
                  Verarbeitung verantwortlich und müssen die Einhaltung des
                  anwendbaren Datenschutzrechts sicherstellen.
                </p>
                <p>
                  In diesem Rahmen haben wir mit LinkedIn eine Vereinbarung zur
                  gemeinsamen Verantwortlichkeit (Joint-Controller-Vertrag) gem.
                  Art. 26 Abs. 2 DSGVO abgeschlossen und LinkedIn hat sich uns
                  gegenüber verpflichtet, die primäre Verantwortung nach der
                  DSGVO für die Verarbeitung dieser Daten zu übernehmen,
                  sämtliche Pflichten aus der DSGVO hinsichtlich dieser Daten zu
                  erfüllen und den betroffenen Personen das Wesentliche dieser
                  Verpflichtung zur Verfügung zu stellen.
                </p>
                <p>Die Vereinbarung können Sie unter folgendem Link abrufen:</p>
                <p>
                  • LinkedIn:
                  <a
                    href="https://legal.linkedin.com/pages-joint-controller-addendum"
                    target="_blank"
                  >
                    https://legal.linkedin.com/pages-joint-controller-addendum</a
                  >
                </p>
                <p>
                  <b
                    >Datenverarbeitungen im Zusammenhang mit unserer
                    LinkedIn-Seite</b
                  >
                </p>
                <p><b>Nutzerstatistiken</b></p>
                <table class="privacy-table">
                  <tr>
                    <th class="privacy-table__heading">
                      (a) Kategorien personenbezogener Daten
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      Wir erhalten von LinkedIn anonyme Statistiken zur
                      Verwendung und Nutzung unserer LinkedIn-Seite (sog.
                      Seiten-Insights). Hierzu verarbeitet LinkedIn:
                      <p>
                        • Profildaten (z.B. Funktion, Land, Branche,
                        Betriebszugehörigkeit, Unternehmensgröße und
                        Beschäftigungsstatus) sowie
                      </p>
                      <p>
                        • Informationen darüber, wie ein Besucher mit unserer
                        LinkedIn-Seite interagiert hat (z.B. ob ein Mitglied ein
                        Follower unserer Seite ist).
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Diese Daten verwendet LinkedIn zu dem Zweck,
                        Besucherstatistiken und Berichte zur Reichweite unserer
                        Seite und Anzeigenperformance sowie demografische und
                        geografische Auswertungen zu erstellen. Wir erhalten
                        diese Statistiken, Berichte und Auswertungen von
                        LinkedIn dabei ausschließlich in anonymisierter Form und
                        haben keinen Zugang zu den jeweils zugrundliegenden
                        Daten.
                      </p>
                      <p>
                        Die anonymen Statistiken ermöglichen es uns, unsere
                        LinkedIn-Seite laufend zu optimieren und den Besuchern
                        ein verbessertes und an ihren Interessen ausgerichtetes
                        Online-Angebot zu bieten. Beispielsweise geben die
                        Statistiken Aufschluss darüber, welche Angebote und
                        Anwendungen unserer Seite die Besucher im besonderen
                        Maße genutzt und interessiert haben. Diese Informationen
                        können wir dazu nutzen, den Besuchern unserer Seite
                        relevantere Inhalte bereitzustellen und Funktionen zu
                        entwickeln, die für sie von größerem Interesse sein
                        könnten. Demografische und geografische Auswertungen
                        ermöglichen es zudem, interessenbasierte Werbung zu
                        schalten, ohne dass wir unmittelbar Kenntnis von der
                        Identität des Besuchers erhalten.
                      </p>
                      <p>
                        Rechtsgrundlage ist
                        <b>Art. 6 Abs. 1 S. 1 lit. f DSGVO</b>. Wir haben ein
                        berechtigtes Interesse an einer optimierten Darstellung
                        unseres Unternehmens und unserer Online-Angebote.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">(c) Speicherdauer</th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir speichern in der Regel selbst keine
                        personenbezogenen Daten zu Kommunikationen und
                        Interaktionen mit Nutzern, die über Social Media
                        Plattformen erfolgen. Für welche Dauer die Daten durch
                        LinkedIn gespeichert werden, entnehmen Sie der
                        Datenschutzerklärung von LinkedIn.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (d) Gemeinsame Verantwortlichkeit
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir sind in Bezug auf die Seiten-Insights gemeinsam mit
                        LinkedIn verantwortlich für die Verarbeitung der
                        personenbezogenen Daten im Zusammenhang mit den
                        Seiten-Insights.
                      </p>
                    </th>
                  </tr>
                </table>
                <p><b>Kommunikation</b></p>
                <table class="privacy-table">
                  <tr>
                    <th class="privacy-table__heading">
                      (a) Kategorien personenbezogener Daten
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Ferner nutzen wir unsere LinkedIn-Seite, um mit
                        LinkedIn-Nutzern zu kommunizieren und über unser
                        Leistungsangebot zu informieren. In diesem Zusammenhang
                        erhalten wir ggf. weitere Informationen, z.B. aufgrund
                        von Nutzerkommentaren, Privatnachrichten oder weil Sie
                        uns folgen oder unsere Inhalte teilen.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Die Verarbeitung erfolgt ausschließlich zum Zwecke der
                        Kommunikation und Interaktion mit Ihnen. Soweit Sie uns
                        über eine Nachricht personenbezogene Daten
                        bereitstellen, verarbeiten wir diese Daten
                        ausschließlich, um Ihre Anfrage zu beantworten und mit
                        Ihnen zu kommunizieren.
                      </p>
                      <p>
                        Rechtsgrundlage ist
                        <b>Art. 6 Abs. 1 S. 1 lit. f DSGVO</b>. Wir haben ein
                        berechtigtes Interesse, Ihre Nachrichten über den von
                        Ihnen gewählten Kanal zu beantworten, mit Ihnen zu
                        kommunizieren und zu interagieren.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">(c) Speicherdauer</th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir speichern in der Regel selbst keine
                        personenbezogenen Daten zu Kommunikationen und
                        Interaktionen mit Nutzern, die über Social Media
                        Plattformen erfolgen. Für welche Dauer die Daten durch
                        LinkedIn gespeichert werden, entnehmen Sie der
                        Datenschutzerklärung von LinkedIn.
                      </p>
                    </th>
                  </tr>
                </table>
                <p><b>Weitergehende Verarbeitungen durch LinkedIn</b></p>
                <p>
                  Bitte beachten Sie, dass auf Seiten von LinkedIn Cookies und
                  andere vergleichbare Speichertechnologien sowohl von LinkedIn
                  als auch von bestimmten Drittanbietern zum Einsatz kommen, um
                  gerätespezifische Daten sowie Informationen zu
                  Nutzeraktivitäten zu sammeln (z.B. Geräte-IDs) und die Nutzer
                  bzw. ihre Endgeräte ggf. auch über verschiedene Dienste und
                  Geräte hinweg zu erkennen. Dies liegt außerhalb unseres
                  Einflusses. Sofern Sie bei LinkedIn selbst ein Profil
                  unterhalten und eingeloggt sind, kann die Erfassung und
                  Auswertung dabei auch personalisiert und geräteübergreifend
                  erfolgen. Auch dies können wir nicht beeinflussen. Wenn Sie
                  dies vermeiden möchten, sollten Sie sich bei LinkedIn abmelden
                  bzw. die Funktion „angemeldet bleiben“ deaktivieren und die
                  auf Ihrem Gerät vorhandenen Cookies löschen.
                </p>
                <p><b>Empfänger und Datenübermittlungen in Drittländer</b></p>
                <p>
                  Wir selbst beabsichtigen nicht, personenbezogene Daten von
                  Nutzern, die wir über unsere LinkedIn-Seite erhalten, an
                  Dritte weiterzugeben. Zu welchen Zwecken und in welchem Umfang
                  LinkedIn die erfassten Informationen an Dritte – ggf.
                  außerhalb der Europäischen Union und des Europäischen
                  Wirtschaftsraum (z.B. an die LinkedIn Inc. mit Sitz in den
                  USA) – weitergibt, beschreibt LinkedIn in seiner
                  Datenschutzerklärung. Bei Datenübermittlungen in die USA und
                  andere Drittländer wird die Einhaltung der
                  datenschutzrechtlichen Standards und Ihrer Rechte nach eigenen
                  Angaben von LinkedIn durch entsprechende Garantien (z.B.
                  Standarddatenschutzklauseln) sichergestellt. LinkedIn
                  Corporation ist zudem unter dem EU-U.S. Data Privacy Framework
                  zertifiziert.
                </p>
                <p>
                  <b
                    >Datenverarbeitungen im Zusammenhang mit unserer
                    YouTube-Seite</b
                  >
                </p>
                <p><b>Darstellung von BIMSWARM</b></p>
                <table class="privacy-table">
                  <tr>
                    <th class="privacy-table__heading">
                      (a) Kategorien personenbezogener Daten
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir nutzen unsere Kanäle insbesondere, um dort aktiven
                        Nutzern und Interessenten interessante Clips über
                        aktuelle Entwicklungen, Neuigkeiten aus unserem
                        Unternehmen oder zu unseren Events bereitzustellen. In
                        diesem Zusammenhang erhalten wir gegebenenfalls weitere
                        Informationen, z.B. aufgrund von Nutzerkommentaren,
                        Bewertungen oder weil Sie uns folgen oder unsere Inhalte
                        teilen.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Die Verarbeitung erfolgt ausschließlich zum Zwecke der
                        Bereitstellung von Videos und Darstellung unseres
                        Unternehmens.
                      </p>
                      <p>
                        Rechtsgrundlage ist
                        <b>Art. 6 Abs. 1 S. 1 lit. f DSGVO</b>. Wir haben ein
                        berechtigtes Interesse, Videos über die genannten Kanäle
                        bereitzustellen und mit den Nutzern zu interagieren.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">(c) Speicherdauer</th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir speichern in der Regel selbst keine
                        personenbezogenen Daten, die über die
                        YouTube-Plattformen erfolgen. Für welche Dauer die Daten
                        durch YouTube gespeichert werden, entnehmen Sie der
                        Datenschutzerklärung von YouTube.
                      </p>
                    </th>
                  </tr>
                </table>
                <p><b>Anonyme Nutzerstatistiken</b></p>
                <table class="privacy-table">
                  <tr>
                    <th class="privacy-table__heading">
                      (a) Kategorien personenbezogener Daten
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir erhalten von YouTube darüber hinaus anonymisierte
                        Nutzungsstatistiken, die uns Aufschluss über folgende
                        Informationen geben:
                      </p>
                      <p>
                        Anzahl der gesamten Videoansichten und durchschnittliche
                        Videoansichten pro Person sowie deren Tendenz (um
                        wieviel sinkend/steigend); Anzahl der Abonnenten sowie
                        deren Tendenz; Anzahl der Besucher des Kanals;
                        Interaktionen von Zuschauern (Likes, Kommentare,
                        geteilte Inhalte); Zeit, die Besucher auf dem Kanal, mit
                        Videos oder bis zur Erteilung eines Abonnements
                        verbracht haben; Reichweite des Videos; prozentualer
                        Anteil der Videos, die ein Nutzer durchschnittlich von
                        den Videos schaut.
                      </p>
                      <p>
                        Die Statistiken beruhen auf Profil- und Nutzerdaten, die
                        die jeweiligen Anbieter mittels Informationen über die
                        Nutzungsaktivitäten (durch sog. „Tracking“) erstellen.
                        Wir erhalten Statistiken von YouTube ausschließlich in
                        anonymisierter Form und haben keinen Zugang zu den
                        jeweils zugrundliegenden Daten.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Die anonymen Statistiken ermöglichen es uns, unsere
                        Kanäle und darin veröffentlichten Videos laufend zu
                        optimieren.
                      </p>
                      <p>
                        Rechtsgrundlage ist
                        <b>Art. 6 Abs. 1 S. 1 lit. f DSGVO</b>. Wir haben ein
                        berechtigtes Interesse an einer optimierten Darstellung
                        unseres Unternehmens und unserer Online-Angebote.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">(c) Speicherdauer</th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        Wir speichern in der Regel selbst keine
                        personenbezogenen Daten der Nutzer unseres
                        YouTube-Kanals. Für welche Dauer die Daten durch YouTube
                        gespeichert werden, entnehmen Sie der
                        Datenschutzerklärung von YouTube.
                      </p>
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__heading">
                      (d) Getrennte Verantwortlichkeit
                    </th>
                  </tr>
                  <tr>
                    <th class="privacy-table__cell">
                      <p>
                        YouTube ist für die Verarbeitung von Nutzer- und
                        Profildaten, insbesondere von Informationen über die
                        Nutzungsaktivitäten, jeweils allein Verantwortliche
                        i.S.d. Art. 4 Nr. 7 DSGVO. Wir selbst verarbeiten
                        insoweit keine personenbezogenen Daten. Informationen zu
                        den durch YouTube verarbeiteten Daten einschließlich der
                        Verarbeitungszwecke und Rechtsgrundlagen stellt YouTube
                        in seiner Datenschutzerklärung bereit.
                      </p>
                    </th>
                  </tr>
                </table>
                <p><b>Weitergehende Verarbeitungen:</b></p>
                <p>
                  Wenn Sie YouTube-Seiten besuchen, verarbeitet YouTube Ihre
                  personenbezogenen Daten gemäß der Datenschutzerklärung. Bitte
                  beachten Sie, dass auf den Seiten von YouTube Cookies und
                  andere vergleichbare Technologien von YouTube selbst, aber
                  auch von Drittanbietern zum Einsatz kommen, um
                  gerätespezifische Daten sowie Informationen zu
                  Nutzeraktivitäten zu sammeln. Diese Daten werden zu Zwecken
                  der Bereitstellung der Online-Dienste und Gewährleistung der
                  Sicherheit sowie zu Analyse-, Werbe- und Messzwecken genutzt.
                  Dies liegt außerhalb unseres Einflusses. Sofern Nutzer die
                  Dienste dieser Anbieter auf mehreren Endgeräten verwenden,
                  kann die Erfassung und Auswertung dabei auch
                  geräteübergreifend erfolgen, wenn es sich um registrierte und
                  jeweils im eigenen Profil angemeldete Besucher handelt. Auch
                  dies können wir nicht beeinflussen. Wenn Sie dies vermeiden
                  möchten, sollten Sie sich bei YouTube abmelden bzw. die
                  Funktion „angemeldet bleiben“ deaktivieren und die auf Ihrem
                  Gerät vorhandenen Cookies löschen. Dann können Sie
                  YouTube-Seiten nutzen, ohne dass Ihre Profil-Kennung offenbart
                  wird.
                </p>
                <p><b>Empfänger und Datenübermittlungen in Drittländer </b></p>
                <p>
                  Innerhalb der Europäischen Union ist die Google Ireland
                  Limited, Gordon House, Barrow Street, Dublin 4, Irland
                  („Google“) der datenschutzrechtlich verantwortliche Anbieter.
                  Soweit personenbezogene Daten auch auf Servern von Google in
                  die USA übertragen und dort gespeichert werden, ist
                  Empfängerin regelmäßig auch die amerikanische Gesellschaft
                  Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA
                  94043, USA. Bei Datenübermittlungen in die USA wird die
                  Einhaltung der datenschutzrechtlichen Standards und Ihrer
                  Rechte nach Angaben von Google durch entsprechende Garantien
                  (z.B. Standarddatenschutzklauseln) sichergestellt. Google LLC
                  ist zudem unter dem EU-U.S. Data Privacy Framework
                  zertifiziert.
                </p>
                <p><b>Cookies</b></p>
                <p>
                  Wie in den einzelnen Abschnitten erläutert, verwenden die
                  Social Media Anbieter sog. Cookies, die beim Besuch unserer
                  Social Media Seiten auch dann auf Ihrem Endgerät abgelegt
                  werden, wenn Sie über kein eigenes Profil verfügen oder in
                  dieses nicht während Ihres Besuchs unserer Seite eingeloggt
                  sind. Diese Cookies erlauben es den Anbietern, Nutzerprofile
                  anhand Ihrer Präferenzen und Interessen zu erstellen und Ihnen
                  darauf abgestimmte Werbung anzuzeigen. Cookies befinden sich
                  so lange auf Ihrem Endgerät, bis Sie sie löschen. Einzelheiten
                  hierzu finden Sie in den Datenschutzerklärungen der Anbieter.
                </p>
                <p>
                  Weitere Informationen zu den Datenverarbeitungen im
                  Zusammenhang mit Cookies finden Sie in den Cookie-Richtlinien
                  der Anbieter:
                </p>
                <p>
                  • YouTube:
                  <a
                    href="https://policies.google.com/technologies/cookies?hl=de&gl=de"
                    target="_blank"
                    >https://policies.google.com/technologies/cookies?hl=de&gl=de</a
                  >
                </p>
                <p>
                  • LinkedIn:
                  <a
                    href="https://de.linkedin.com/legal/cookie-policy?_l=de_DE"
                    target="_blank"
                    >https://de.linkedin.com/legal/cookie-policy?_l=de_DE</a
                  >
                </p>
              </li>

              <!-- -------------------------------------------------------------------------------------------------------------------------------------------------------->

              <li id="Cookies" class="section level-2">
                <h3>4.5 Cookies und Tracking-Technologien</h3>
              </li>
              <ol>
                <li id="AllgInfoCookies" class="section level-3">
                  <div class="sub-header sub-header--tight">
                    4.5.1 Allgemeine Informationen zu Cookies
                  </div>

                  <p>
                    Auf unserer Plattform nutzen wir Cookies. Bei Cookies
                    handelt es sich um kleine Textdateien, die auf Ihrer
                    Festplatte dem von Ihnen verwendeten Browser durch eine
                    charakteristische Zeichenfolge zugeordnet und gespeichert
                    werden und durch welche der Stelle, die das Cookie setzt,
                    bestimmte Informationen zufließen. Cookies können keine
                    Programme ausführen oder Viren auf Ihren Computer übertragen
                    und daher keine Schäden anrichten. Sie dienen dazu, das
                    Internetangebot insgesamt nutzerfreundlicher und effektiver,
                    also für Sie angenehmer zu machen.
                  </p>
                  <p>
                    Cookies können Daten enthalten, die eine Wiedererkennung des
                    genutzten Geräts möglich machen. Teilweise enthalten Cookies
                    aber auch lediglich Informationen zu bestimmten
                    Einstellungen, die nicht personenbeziehbar sind. Cookies
                    können einen Nutzer aber nicht direkt identifizieren. Ein
                    Cookie dient in erster Linie dazu, die Informationen über
                    einen Benutzer während oder nach seinem Besuch innerhalb
                    eines Onlineangebotes zu speichern. Zu den gespeicherten
                    Angaben können z.B. die Spracheinstellungen auf einer
                    Webseite, der Loginstatus, ein Warenkorb oder die Stelle, an
                    der ein Video geschaut wurde, gehören.
                  </p>
                  <p>
                    Man unterscheidet zwischen
                    <b>Session-Cookies</b>, die wieder gelöscht werden, sobald
                    Sie ihren Browser schließen und <b>permanenten Cookies</b>,
                    die über die einzelne Sitzung hinaus gespeichert werden.
                    Daneben unterscheidet man zwischen
                    <b>First-Party-Cookies</b> (diese werden von uns selbst
                    gesetzt) und <b>Third-Party-Cookies</b> (diese werden
                    hauptsächlich von Werbetreibenden, d.h. Dritten, verwendet),
                    um Benutzerinformationen zu verarbeiten.
                  </p>
                  <p>
                    Hinsichtlich ihrer Funktion unterscheidet man bei Cookies
                    wiederum zwischen:
                  </p>
                  <ul>
                    <li>
                      <p>
                        • <b>Zwingend erforderliche Cookies</b>: Diese Cookies
                        sind für das Funktionieren unserer Websites unerlässlich
                        und ermöglichen es Ihnen, sich auf unseren Websites zu
                        bewegen und deren Funktionen zu nutzen. Ohne diese
                        Cookies können bestimmte Dienste, die für das
                        vollständige Funktionieren unserer Websites erforderlich
                        sind, nicht bereitgestellt werden.
                      </p>
                    </li>
                    <li>
                      <p>
                        • <b>Analyse/Performance Cookies</b>: Mit Hilfe dieser
                        Cookies sammeln wir Informationen darüber, wie unsere
                        Nutzer unsere Websites nutzen, z. B. welche Seiten am
                        häufigsten aufgerufen und gelesen werden oder wie die
                        Nutzer von einem Link zum nächsten wechseln. Alle
                        Informationen, die durch diese Art von Cookies gesammelt
                        werden, beziehen sich nicht auf einen einzelnen Nutzer,
                        sondern werden mit den Informationen anderer Nutzer
                        zusammengefasst und verarbeitet. Cookies liefern uns
                        analytische Daten darüber, wie unsere Websites
                        funktionieren und wie wir sie verbessern können.
                      </p>
                    </li>
                    <li>
                      <p>
                        • <b>Funktionsbezogene Cookies</b>: Diese Cookies
                        ermöglichen es uns, eine bestimmte Auswahl, die Sie
                        getroffen haben, zu speichern und unsere Website so
                        anzupassen, dass sie Ihnen erweiterte Funktionen und
                        Inhalte bietet. Diese Cookies können z.B. dazu verwendet
                        werden, Ihre Sprachauswahl oder Länderauswahl zu
                        speichern.
                      </p>
                    </li>
                    <li>
                      <p>
                        • <b>Marketing-Cookies</b>: Diese Cookies speichern
                        Ihren Besuch auf unserer Webseite, die Seiten, die Sie
                        besucht haben, und die Links, denen Sie gefolgt sind.
                        Wir verwenden diese Informationen, um unsere Website und
                        die darauf angezeigte Werbung sowie die von uns an Sie
                        gesendeten Marketingnachrichten besser auf Ihre
                        Interessen abzustimmen. Wir können diese Informationen
                        auch an Dritte weitergeben, die uns zu diesem Zweck
                        einen Dienst erbringen.
                      </p>
                    </li>
                    <li>
                      <p>
                        • <b>Cookies sozialer Netzwerke</b>: Um den Austausch
                        von Inhalten im Internet zu erleichtern, können einige
                        unserer Internetseiten kleine Softwareanwendungen von
                        Drittanbietern, z.B. Twitter oder LinkedIn, zum
                        Austausch von Daten enthalten. Dabei werden die Cookies
                        nicht von uns, sondern von dem Drittanbieter auf Ihrem
                        Gerät gespeichert. Wir können diese Cookies nicht
                        kontrollieren. Für weitere Informationen sollten Sie
                        daher die Internetseite des Drittanbieters besuchen.
                      </p>
                    </li>
                  </ul>
                  <p>
                    Jeder Einsatz von Cookies, der nicht zwingend technisch
                    erforderlich ist, stellt eine Datenverarbeitung dar, die nur
                    mit einer ausdrücklichen und aktiven Einwilligung Ihrerseits
                    gem. § 25 Abs. 1 TDDDG, Art. 6 Abs. 1 S. 1 lit. a DSGVO
                    erlaubt ist. Eine Einwilligung ist stets freiwillig. Die
                    Verweigerung der Einwilligung oder ein Widerruf derselben
                    hat keine negativen Auswirkungen auf Sie. Darüber hinaus
                    geben wir Ihre durch Cookies verarbeiteten personenbezogenen
                    Daten nur an Dritte weiter, wenn Sie nach Art. 6 Abs. 1 S. 1
                    lit. a DSGVO eine ausdrückliche Einwilligung dazu erteilt
                    haben. Die Erteilung einer Einwilligung ist nicht
                    erforderlich, wenn der Einsatz der Cookies für das Angebot
                    der Plattform erforderlich ist. Rechtsgrundlage hierfür ist
                    dann § 25 Abs. 2 Nr. 2 TDDDG. Eine derartige
                    Erforderlichkeit ist beispielweise hinsichtlich der
                    Sicherstellung bestimmte Funktionalitäten gegeben, etwa:
                  </p>
                  <p>• Ermöglichung und Aufrechterhaltung eines Log-ins,</p>
                  <p>• Gewährleistung der Systemsicherheit.</p>
                  <p>
                    Wie lange werden Cookies auf meinen Geräten gespeichert?
                  </p>
                  <p>
                    Die Speicherdauer hängt wesentlich davon ab, ob es sich um
                    einen „dauerhaften“ oder „sitzungsbezogenen“ Cookie handelt.
                    Sitzungsbezogene Cookies werden gelöscht, nachdem Sie die
                    Plattform verlassen haben. Dauerhafte Cookies verbleiben auf
                    Ihrem Gerät, bis sie gelöscht werden oder sie abgelaufen
                    sind.
                  </p>
                  <p>
                    <b>Allgemeine Hinweise zum Widerruf und Widerspruch</b>:
                    Abhängig davon, ob die Verarbeitung auf Grundlage einer
                    Einwilligung oder gesetzlichen Erlaubnis erfolgt, haben Sie
                    jederzeit die Möglichkeit, eine erteilte Einwilligung zu
                    widerrufen oder der Verarbeitung Ihrer Daten durch
                    Cookie-Technologien zu widersprechen (zusammenfassend als
                    "Opt-Out" bezeichnet). Sie können Ihren Widerspruch zunächst
                    mittels der Einstellungen Ihres Browsers erklären, z.B.,
                    indem Sie die Nutzung von Cookies deaktivieren (wobei
                    hierdurch auch die Funktionsfähigkeit unseres
                    Onlineangebotes eingeschränkt werden kann). Ein Widerspruch
                    gegen den Einsatz von Cookies zu Zwecken des
                    Onlinemarketings kann auch mittels einer Vielzahl von
                    Diensten, vor allem im Fall des Trackings, über die
                    Webseiten https://optout.aboutads.info und
                    https://www.youronlinechoices.com erklärt werden. Daneben
                    können Sie weitere Widerspruchshinweise im Rahmen der
                    Angaben zu den eingesetzten Dienstleistern und Cookies
                    erhalten.
                  </p>
                </li>

                <!-- ---------------------------------------------------------------------------------------------------------------------------------->

                <li id="DrittanbieterCookies" class="section level-3">
                  <div class="sub-header sub-header--tight">
                    4.5.2 Cookies von Drittanbietern und Social-Media-Plugins
                  </div>
                  <p>
                    Um Ihnen eine komfortable Plattform anbieten zu können,
                    nutzen wir unter anderem Matomo.
                  </p>
                  <p>
                    <b
                      >Auf unserer Plattform werden folgende Cookies
                      verwendet:</b
                    >
                  </p>
                  <table class="matomo-cookies-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Zweck</th>
                        <th>Ablauf</th>
                        <th>Typ</th>
                        <th>Anbieter</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td scope="row">_pk_id</td>
                        <td>
                          Wird verwendet, um ein paar Details über den Benutzer
                          wie die eindeutige Besucher-ID zu speichern.
                        </td>
                        <td>13 Monate</td>
                        <td>HTML</td>
                        <td>Matomo</td>
                      </tr>

                      <tr>
                        <td scope="row">_pk_ref</td>
                        <td>
                          Wird benutzt, um die Informationen der
                          Herkunftswebsite des Benutzers zu speichern.
                        </td>
                        <td>6 Monate</td>
                        <td>HTML</td>
                        <td>Matomo</td>
                      </tr>

                      <tr>
                        <td scope="row">_pk_ses</td>
                        <td>
                          Kurzzeitiges Cookie, um vorübergehende Daten des
                          Besuchs zu speichern.
                        </td>
                        <td>30 Minuten</td>
                        <td>HTML</td>
                        <td>Matomo</td>
                      </tr>

                      <tr>
                        <td scope="row">_pk_cvar</td>
                        <td>
                          Kurzzeitiges Cookie, um vorübergehende Daten des
                          Besuchs zu speichern.
                        </td>
                        <td>30 Minuten</td>
                        <td>HTML</td>
                        <td>Matomo</td>
                      </tr>

                      <tr>
                        <td scope="row">_pk_hsr</td>
                        <td>
                          Kurzzeitiges Cookie, um vorübergehende Daten des
                          Besuchs zu speichern.
                        </td>
                        <td>30 Minuten</td>
                        <td>HTML</td>
                        <td>Matomo</td>
                      </tr>
                    </tbody>
                  </table>
                </li>

                <ol>
                  <li id="Matomo" class="section level-4">
                    <div class="sub-header sub-header--tight">
                      4.5.2.1 Einsatz von Matomo
                    </div>
                    <p>
                      Auf unserer BIMSWARM Plattform nutzen wir den
                      Webanalysedienst Matomo, um die Nutzung unserer Plattform
                      zu analysieren. Über die gewonnenen Statistiken können wir
                      unser Angebot verbessern und für Sie als Nutzer
                      interessanter ausgestalten. Matomo erstellt
                      Nutzungsprofile auf Grundlage von Pseudonymen. Zu diesem
                      Zweck werden dauerhafte Cookies auf Ihrem Endgerät
                      gespeichert, die wir auslesen können. Dadurch sind wir in
                      der Lage, wiederkehrende Besucher zu identifizieren und zu
                      zählen. Zusätzlich nutzen wir die Funktionen Heatmap und
                      Session Recording. Der Heatmap-Dienst von Matomo zeigt
                      uns, welche Bereiche unserer Plattform am häufigsten mit
                      der Maus bewegt oder angeklickt werden. Mit dem
                      Session-Recording-Dienst zeichnen wir einzelne
                      Nutzersitzungen auf, die wir im Nachhinein abspielen
                      können, um die Nutzung der Plattform zu analysieren.
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten und Umfang der
                          Verarbeitung
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Matomo setzt die unter Ziff. 4.5.2 genannten
                            Cookies. Insofern werden die folgenden Daten
                            erfasst:
                          </p>
                          <p>
                            • Metadaten wie URL, Referrer-URL, IP-Adresse,
                            Geräte- und Browsereigenschaften (User Agent),
                            Spracheinstellungen,
                          </p>
                          <p>• Zeitstempel sowie</p>
                          <p>
                            • Informationen über Seitenereignisse (z.B.
                            Seitenabrufe).
                          </p>
                          <p>
                            Die erhobenen Informationen speichern wir auf
                            unserem Server.
                          </p>
                          <p>
                            Diese Plattform verwendet Matomo mit der Erweiterung
                            „AnonymizeIP“. Dadurch werden IP-Adressen gekürzt
                            weiterverarbeitet und eine direkte
                            Personenbeziehbarkeit ausgeschlossen. Die mittels
                            Matomo von Ihrem Browser übermittelte IP-Adresse
                            wird nicht mit anderen von uns erhobenen Daten
                            zusammengeführt.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Wir nutzen Matomo zu den vorstehend beschriebenen
                            Analyse- und Optimierungszwecken.
                          </p>
                          <p>
                            Wir setzen Matomo nur ein, wenn Sie über unseren
                            Cookie-Banner Ihre ausdrückliche Einwilligung in den
                            Einsatz von Marketing-Cookies erteilt haben.
                            Rechtsgrundlage ist
                            <b
                              >§ 25 Abs. 1 TDDDG, Art. 6 Abs. 1 S. 1 lit. a
                              DSGVO</b
                            >.
                          </p>
                          <p>
                            Sie können Ihre einmal erteilte Einwilligung in den
                            Einsatz von Matomo jederzeit widerrufen, indem Sie
                            den Einsatz von Marketing-Cookies über den
                            Cookie-Banner deaktivieren.
                          </p>
                          <p>
                            Darüber hinaus können die Erfassung der durch die
                            Cookies erzeugten und auf Ihre Webseitennutzung
                            bezogenen Daten durch Matomo sowie die Nutzung Ihrer
                            personenbezogenen Daten zu Analysezwecken
                            verhindern, indem Sie Matomo auf unserer Plattform
                            deaktivieren („Opt-out“). Ferner können Sie ein
                            Opt-Out-Cookie setzen, das die zukünftige Erfassung
                            Ihrer Daten beim Besuch dieser Plattform verhindert.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Konkrete Angaben zur Funktionsdauer der jeweiligen
                            Cookies können Sie der Ziff. 4.5.2 entnehmen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">(d) Empfänger</th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Empfänger ist die InnoCraft Ltd., 150 Willis St,
                            6011 Wellington, Neuseeland. Wir selbst
                            beabsichtigen nicht, personenbezogene Daten von
                            Nutzern an Dritte weiterzugeben.
                          </p>
                        </th>
                      </tr>
                    </table>
                    <p>
                      Weitere Informationen zu den Nutzungsbedingungen von
                      Matomo und den datenschutzrechtlichen Regelungen finden
                      Sie unter:
                      <a href="https://matomo.org/privacy/" target="_blank"
                        >https://matomo.org/privacy/</a
                      >.
                    </p>
                  </li>

                  <!-- ------------------------------------------------------------------------------------------------------------------->

                  <li id="YouTube" class="section level-4">
                    <div class="sub-header sub-header--tight">
                      4.5.2.2 YouTube Videos
                    </div>
                    <p>
                      Wir nutzen auf unseren BIMSWARM-Webseiten die Dienste des
                      Videoportals YouTube LLC, 901 Cherry Ave. 94066 San Bruno,
                      CA, USA, zur Einbindung von Videos.
                    </p>
                    <p>
                      Die Datenschutzerklärung für <b>YouTube</b>, das von
                      Google Ireland Limited, Gordon House, Barrow Street,
                      Dublin 4, Irland, betrieben wird, können Sie unter
                      <a
                        target="_blank"
                        href="https://policies.google.com/privacy?hl=de"
                        >https://policies.google.com/privacy?hl=de</a
                      >
                      einsehen.
                    </p>
                    <p>
                      Die Einbindung von YouTube-Videos ermöglicht es Ihnen, die
                      Videos einfach und komfortabel direkt über unsere Seite
                      anzusehen. YouTube-Videos sind dabei im „erweiterten
                      Datenschutzmodus“ eingebettet. Nach Angaben des Anbieters
                      werden deshalb beim bloßen Aufruf unserer Seite keine
                      Daten über Sie als Nutzer an YouTube übertragen und keine
                      Nutzerprofile erstellt, solange Sie das Video nicht
                      abspielen. Die Anzeige dieser Videos ist auf unserer Seite
                      zudem standardmäßig deaktiviert. Das hat zur Folge, dass
                      beim bloßen Aufruf einer Seite, auf der ein Video
                      eingebettet ist, keine Cookies von YouTube gesetzt und
                      keine Daten über Sie als Nutzer an YouTube übertragen
                      werden. Erst nach bewusstem Anklicken des „YouTube
                      laden“-Buttons wird das Video geladen und eine Verbindung
                      zum Server von YouTube aufgebaut. Cookies werden im
                      „erweiterten Datenschutzmodus“ nicht gesetzt.
                    </p>
                    <p>
                      <b>
                        Mit Anklicken des „YouTube laden“-Buttons oder dem
                        Akzeptieren des Einsatzes von YouTube über den
                        Cookie-Banner erklären Sie sich mit dadurch ausgelösten
                        Datenverarbeitungen durch die Drittanbieter
                        einverstanden.
                      </b>
                    </p>
                    <table class="privacy-table">
                      <tr>
                        <th class="privacy-table__heading">
                          (a) Kategorien personenbezogener Daten
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Nach Freigabe dieser Funktion durch Anklicken des
                            „Video aktivieren“-Buttons werden die Videos auf
                            unserer Seite geladen und YouTube erhält die URL der
                            gerade geladenen Webseite, die IP-Adresse des von
                            Ihnen genutzten Endgerätes sowie ggf. weitere
                            gerätespezifische Informationen (z.B. Browsertyp).
                            Dies erfolgt unabhängig davon, ob Sie ein
                            Mitgliedskonto haben oder nicht. Soweit Sie über ein
                            Mitgliedskontoverfügen, über das Sie eingeloggt
                            sind, können Ihre Daten durch YouTube direkt auch
                            Ihrem Konto zugeordnet werden (z.B. welches Video
                            Sie aufrufen). Dies können Sie verhindern, indem Sie
                            sich vor Abspielen eines Videos von Ihrem
                            Mitgliedskonto abmelden. Darüber hinaus können nach
                            dem Abspielen eines YouTube-Videos auch weitere
                            Datenverarbeitungsvorgänge seitens YouTube ausgelöst
                            werden, von denen wir keine genaue Kenntnis und auf
                            die wir keinen Einfluss haben.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (b) Zwecke und Rechtsgrundlage der Datenverarbeitungen
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Die Verarbeitung erfolgt ausschließlich zum Zwecke
                            der Bereitstellung von Videos und Darstellung
                            unseres Unternehmens. Eine Übertragung der Daten an
                            YouTube erfolgt nur, wenn Sie uns bei Abspielen
                            eines YouTube-Videos über den „Video
                            aktivieren“-Button Ihre Einwilligung gem.
                            <b
                              >§ 25 Abs. 1 TDDDG, Art. 6 Abs. 1 S. 1 lit. a
                              DSGVO</b
                            >
                            erteilt haben. Auf welcher Rechtsgrundlage die
                            jeweiligen Anbieter Ihre Daten verarbeiten,
                            entnehmen Sie bitte der Datenschutzerklärung der
                            jeweiligen Anbieter (s.o.).
                          </p>
                          <p>
                            <b>Widerruf und Deaktivierung:</b> Sie können eine
                            Übermittlung von Informationen an Google jederzeit
                            unterbinden, indem Sie die auf unserer Seite
                            eingebetteten Videos nicht abspielen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">
                          (c) Speicherdauer
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Konkrete Angaben zur Speicherdauer können Sie der
                            oben verlinkten Datenschutzerklärungen von YouTube
                            entnehmen.
                          </p>
                        </th>
                      </tr>
                      <tr>
                        <th class="privacy-table__heading">(d) Empfänger</th>
                      </tr>
                      <tr>
                        <th class="privacy-table__cell">
                          <p>
                            Innerhalb der Europäischen Union ist die Google
                            Ireland Limited, Gordon House, Barrow Street, Dublin
                            4, Irland („Google“) der datenschutzrechtlich
                            verantwortliche Anbieter dieses Dienstes. Soweit
                            personenbezogene Daten auch auf Servern von Google
                            in die USA übertragen und dort gespeichert werden,
                            ist Empfängerin regelmäßig auch die amerikanische
                            Gesellschaft Google LLC, 1600 Amphitheatre Parkway,
                            Mountain View, CA 94043, USA. Bei
                            Datenübermittlungen in die USA wird die Einhaltung
                            der datenschutzrechtlichen Standards und Ihrer
                            Rechte nach Angaben von Google durch entsprechende
                            Garantien (z.B. Standarddatenschutzklauseln)
                            sichergestellt. Informationen zum Datenschutz bei
                            YouTube finden Sie in der Datenschutzerklärung von
                            Google. Google LLC ist zudem unter dem EU-U.S. Data
                            Privacy Framework zertifiziert.
                          </p>
                        </th>
                      </tr>
                    </table>
                    <p>
                      Weitere Informationen zu Zweck und Umfang der
                      Datenerhebung und -verarbeitung durch YouTube sowie zu
                      Ihren Rechten und Einstellungsmöglichkeiten zum Schutze
                      Ihrer Privatsphäre erhalten Sie in der
                      Datenschutzerklärung von YouTube.
                    </p>
                    <p>
                      Die Bereitstellung Ihrer Daten erfolgt freiwillig. Sie
                      können unsere Internetseiten grundsätzlich auch ohne
                      YouTube nutzen. Wir weisen Sie darauf hin, dass Sie dann
                      nicht alle Funktionen dieser Seite nutzen, insbesondere
                      keine Videos abspielen können.
                    </p>
                  </li>
                </ol>
              </ol>
            </ol>
          </ul>
        </li>

        <!-- ----------------------------------------------------------------------------------------------------------------------------------->

        <li id="Erhebung">
          <h2>5 Bei wem erheben wir Ihre personenbezogenen Daten?</h2>
          <p>
            Personenbezogene Daten werden ausschließlich bei Ihnen direkt
            erhoben, beispielsweise wenn Sie unsere Webseite oder die BIMSWARM
            Plattform besuchen oder sich zu unserem Newsletter anmelden.
          </p>
        </li>

        <!-- ----------------------------------------------------------------------------------------------------------------------------------->

        <li id="Weitergabe">
          <h2>6 An wen geben wir Ihre personenbezogenen Daten weiter?</h2>
          <p>
            BIMSWARM gibt Ihre personenbezogenen Daten nur weiter, wenn dies
            nach europäischem Datenschutzrecht zulässig ist, z. B. weil die
            Datenübermittlung für die Erfüllung eines Vertrages erforderlich ist
            oder weil Sie uns Ihre Einwilligung zur Weitergabe der Daten erteilt
            haben. Wir arbeiten mit einigen Dienstleistern zusammen, wie z. B.
            technischen Dienstleistern (z. B. Hosting-Dienste, Pflege der
            Website, Unterstützung unserer Marketingaktivitäten, Bereitstellung
            von Kommunikationsmitteln).
          </p>

          <ul>
            <ol>
              <li id="WeitergabePflichten" class="section level-2">
                <h3>
                  6.1 Weitergabe aufgrund gesetzlicher Pflichten oder zur
                  Wahrung berechtigter Interessen
                </h3>
                <p>
                  Soweit wir gesetzlich, per Gerichtsbeschluss oder aufgrund
                  einer vollziehbaren behördlichen Anordnung dazu verpflichtet
                  sind, müssen wir Ihre personenbezogenen Daten an
                  auskunftsberechtigte Stellen (z.B. Aufsichts- oder
                  Finanzbehörden) übermitteln. Rechtsgrundlage für die
                  Weitergabe ist dann Art. 6 Abs. 1 S. 1 lit. c DSGVO. 6.2
                  Auftragsdatenverwaltung Es kann vorkommen, dass für einzelne
                  Angebote auf beauftragte Dienstleister („Auftragsverarbeiter“)
                  zurückgegriffen wird. Diese werden nur nach unserer Weisung
                  tätig und wurden im Sinne von Art. 28 DSGVO vertraglich dazu
                  verpflichtet, die datenschutzrechtlichen Bestimmungen
                  einzuhalten. Auch die Auftragsverarbeiter sind vertraglich
                  verpflichtet, z. B. die personenbezogenen Daten nach
                  Beendigung des Auftrags entweder zu löschen oder
                  zurückzugeben. Folgende Kategorien von Empfängern, bei denen
                  es sich im Regelfall um Auftragsverarbeiter handelt, erhalten
                  ggf. Zugriff auf Ihre personenbezogenen Daten:
                </p>
                <p>
                  • IT- und Web-Dienstleister bzw. Unternehmen, die im Rahmen
                  der Betreuung unserer Webseite bzw. Plattform und
                  unternehmensinternen IT-Infrastruktur (Software, Hardware)
                  beauftragt werden. Rechtsgrundlage für die Weitergabe ist Art.
                  6 Abs. 1 S. 1 lit. b oder lit. f DSGVO. Unsere wichtigsten
                  Auftragsverarbeiter sind projectfacts (betrieben von 5 POINT
                  AG, Rheinstraße 40-42, 64283 Darmstadt für das Marketing),
                  WordPress (für den Betrieb unserer Website), Mittwald CM
                  Service GmbH & Co.KG (Königsberger Str. 4 - 6, 32339
                  Espelkamp), und adesso as a service GmbH (Adessoplatz 1, 44269
                  Dortmund) für Hosting-Dienste (mit Servern in Deutschland),
                  Oranto GmbH, Richard-Sorge-Str. 11, 10249
                  Berlin-Friedrichshain, Fon: +49 30 37 000 910, info@oranto.de
                  (Typo3-Support)
                </p>
                <p>
                  • Zahlungsdienstleister zur Abwicklung von Zahlungen. Ihre
                  Zahlungsdaten können an Zahlungsdienstleister übermittelt
                  werden, mit denen wir zusammenarbeiten. Weitere Informationen
                  über die Verarbeitung personenbezogener Daten durch
                  Zahlungsdienstleister finden Sie unter Ziff. 4.2.4.
                </p>
              </li>

              <!-- ---------------------------------------------------------------------------------------------------------------------------------->

              <li id="VerbundeneUnternehmen" class="section level-2">
                <h3>6.2 Verbundene Unternehmen und Produktanbieter</h3>
                <p>
                  Zudem können Ihre personenbezogenen Daten an verbundene
                  Unternehmen sowie an die Anbieter von Produkten auf der
                  BIMSWARM Plattform weitergegeben werden. Eine Weitergabe Ihrer
                  Daten ist beispielsweise erforderlich, wenn Sie bestimmte
                  Leistungen auf unserer BIMSWARM Plattform in Anspruch nehmen
                  wollen, wie etwa eine Demo-Version eines Produktes anfragen.
                  Rechtsgrundlage ist dann Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                  Ferner werden Ihre Daten aus organisatorischen Gründen an die
                  planen-bauen 4.0 Gesellschaft zur Digitalisierung des Planens,
                  Bauens und Betreibens mbH, Geneststraße 5, 10829 Berlin
                  weitergegeben, da wir zur Abwicklung der Vertragsverhältnisse
                  die personellen Ressourcen unserer Muttergesellschaft nutzen.
                </p>
                <p>
                  Darüber hinaus geben wir Ihre personenbezogenen Daten nur an
                  Dritte weiter, wenn Sie nach Art. 6 Abs. 1 S. 1 lit. a DSGVO
                  eine ausdrückliche Einwilligung dazu erteilt haben.
                </p>
              </li>
            </ol>
          </ul>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Datenuebermittlung">
          <h2>7 Erfolgt eine Datenübermittlung an Drittländer?</h2>
          <p>
            Im Rahmen unserer Geschäftsbeziehungen können Ihre personenbezogenen
            Daten an Drittgesellschaften weitergegeben oder offengelegt werden.
            Diese können sich auch außerhalb der Europäischen Union
            („<b>EU</b>“) oder des Europäischen Wirtschaftsraums („<b>EWR</b>“),
            in sogenannten Drittländern, befinden. Eine derartige Verarbeitung
            erfolgt ausschließlich zur Erfüllung der vertraglichen und
            geschäftlichen Verpflichtungen und zur Pflege Ihrer
            Geschäftsbeziehung zu uns.
          </p>
          <p>
            Einigen Drittländern bescheinigt die Europäische Kommission durch
            sog. Angemessenheitsbeschlüsse einen Datenschutz, der dem
            EU-Standard vergleichbar ist (eine Liste dieser Länder sowie eine
            Kopie der Angemessenheitsbeschlüsse erhalten Sie hier:
            http://ec.europa.eu/justice/data-protection/international-transfers/adequacy/index_en.html).
          </p>
          <p>
            In anderen Drittländern, in die ggf. personenbezogene Daten
            übertragen werden, herrscht aber unter Umständen wegen fehlender
            gesetzlicher Bestimmungen kein mit der EU vergleichbares
            Datenschutzniveau. Dies kann bedeuten, dass Ihre personenbezogenen
            Daten in einer Rechtsordnung verarbeitet werden, die ein
            Schutzniveau bietet, das in bestimmten Fällen weniger Schutz für
            Ihre personenbezogenen Daten bietet als die Rechtsordnung, in der
            Sie normalerweise ansässig sind. Soweit dies der Fall ist, achten
            wir darauf, dass der Datenschutz ausreichend gewährleistet ist und
            entsprechende Garantien bestehen. Das heißt, wir schließen
            beispielsweise die Standardvertragsklauseln der Europäischen
            Kommission zum Schutz personenbezogener Daten ab.
          </p>
          <p>
            Bitte wenden Sie sich an unseren Datenschutzbeauftragten (siehe
            unter Ziffer 3.3), wenn Sie hierzu nähere Informationen erhalten
            möchten.
          </p>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="PersonenbezogeneDaten">
          <h2>8 Wie lange speichern wir Ihre personenbezogenen Daten?</h2>
          <p>
            Soweit unter Ziffer 4 keine ausdrückliche Speicherdauer angegeben
            ist, speichern wir Ihre personenbezogenen Daten grundsätzlich nur
            solange, wie wir die Daten für die Zwecke, für die wir sie erhoben
            haben, und für die Erfüllung rechtlicher Vorgaben und Pflichten
            benötigen. Eine Speicherung Ihrer Daten erfolgt grundsätzlich nur
            auf unseren Servern in Deutschland, vorbehaltlich einer ggf.
            erfolgenden Weitergabe nach den Regelungen in Ziffer 6 und 7.
          </p>
          <p>
            Eine Speicherung kann jedoch über die angegebene Zeit hinaus im
            Falle einer (drohenden) Rechtsstreitigkeit mit Ihnen oder eines
            sonstigen rechtlichen Verfahrens erfolgen oder wenn die Speicherung
            durch gesetzliche Vorschriften, denen wir als Verantwortlicher
            unterliegen (z.B. § 257 HGB oder § 147 AO), vorgesehen ist. Wenn die
            durch die gesetzlichen Vorschriften vorgeschriebene Speicherfrist
            abläuft, erfolgt eine Sperrung oder Löschung der personenbezogenen
            Daten, es sei denn, dass eine weitere Speicherung durch uns
            erforderlich ist und dafür eine Rechtsgrundlage besteht.
          </p>
        </li>

        <li id="rechteNutzer">
          <h2>9 Welche Rechte haben Sie als betroffene Nutzer?</h2>
          <p>
            Wenn Sie von Ihren nachfolgend beschriebenen Betroffenenrechten
            Gebrauch machen möchten, wenden Sie sich bitte formlos an
            datenschutz&#64;bimswarm.de oder nutzen die unter Ziffer 3
            angegebene Postadresse.
          </p>
          <ul>
            <ol>
              <p>
                • <b>Recht auf Auskunft</b>: Unter den Voraussetzungen des Art.
                15 DSGVO können Sie jederzeit Auskunft über Ihre von uns
                verarbeiteten personenbezogenen Daten sowie eine Kopie Ihrer
                Daten verlangen.
              </p>
              <p>
                • <b> Recht auf Berichtigung</b>: Unter den Voraussetzungen des
                Art. 16 DSGVO können Sie unverzüglich die Berichtigung
                unrichtiger oder Vervollständigung unvollständiger Daten zu
                Ihrer Person verlangen.
              </p>
              <p>
                •<b> Recht auf Löschung</b> : Darüber hinaus können Sie unter
                den Voraussetzungen des Art. 17 DSGVO die Löschung Ihrer bei uns
                gespeicherten personenbezogenen Daten verlangen.
              </p>
              <p>
                • Recht auf Einschränkung der Verarbeitung: Nach Maßgabe von
                Art. 18 DSGVO können Sie ferner die Einschränkung der
                Verarbeitung Ihrer personenbezogenen Daten verlangen.
              </p>
              <p>
                •<b> Recht auf Auskunft über Empfänger</b>: Nach Art. 19 DSGVO
                haben Sie das Recht Auskunft über die Empfänger von Daten zu
                verlangen, denen eine Berichtigung, Löschung Ihrer
                personenbezogenen Daten oder eine Einschränkung der Verarbeitung
                mitgeteilt wurde.
              </p>
              <p>
                •<b> Recht auf Datenübertragbarkeit</b>: Unter den
                Voraussetzungen des Art. 20 DSGVO haben Sie das Recht, Ihre
                personenbezogenen Daten in einem strukturierten, gängigen und
                maschinenlesbaren Format zu erhalten oder die Übermittlung
                unmittelbar an einen anderen Verantwortlichen zu verlangen.
              </p>
              <p>
                •<b> Widerrufsrecht</b>: Sollten wir personenbezogene Daten
                aufgrund einer Ihrerseits erteilten Einwilligung verarbeiten,
                sind Sie zudem berechtigt, Ihre Einwilligung gemäß Art. 7 Abs. 3
                DSGVO jederzeit zu widerrufen. Ihr Widerruf hat zur Folge, dass
                wir die Datenverarbeitung, die bis dahin auf dieser Einwilligung
                beruht, für die Zukunft nicht mehr fortführen. Die
                Rechtmäßigkeit der aufgrund Ihrer Einwilligung bis zum Widerruf
                erfolgten Verarbeitung bleibt von Ihrem Widerruf unberührt.
              </p>
              <p>
                •<b> Beschwerderecht</b>: Sofern Sie der Auffassung sind, dass
                die Verarbeitung der Sie betreffenden personenbezogenen Daten
                durch uns gegen datenschutzrechtliche Bestimmungen verstößt,
                steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde
                nach Art. 77 DSGVO zu. In Berlin ist der Berliner Beauftragte
                für Datenschutz und Informationsfreiheit (BInBDI) die zuständige
                Aufsichtsbehörde (Friedrichstr. 219, 10969 Berlin,
                mailbox&#64;datenschutz-berlin.de).
              </p>
              <p>
                <b>WIDERSPRUCHSRECHT</b>: UNTER DEN VORAUSSETZUNGEN DES ART. 21
                DSGVO HABEN SIE ZUDEM DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER
                BESONDEREN SITUATION ERGEBEN, JEDERZEIT DER VERARBEITUNG IHRER
                PERSONENBEZOGENEN DATEN ZU WIDERSPRECHEN, SOFERN DIE
                VERARBEITUNG AUF EINEM BERECHTIGTEN INTERESSE VON UNS ODER EINES
                DRITTEN GEMÄSS ART. 6 ABS. 1 S. 1 LIT. F DSGVO ODER AUF ART. 6
                ABS. 1 S. 1 LIT. E DSGVO BERUHT (DIES GILT AUCH FÜR EIN AUF
                DIESE BESTIMMUNGEN GESTÜTZTES PROFILING.). WIR WERDEN DIE
                VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN EINSTELLEN, ES SEI
                DENN, WIR KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE
                VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND
                FREIHEITEN ÜBERWIEGEN, ODER WENN DIE VERARBEITUNG DER
                GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
                DIENT.
              </p>

              <p>
                NACH <b>ART. 21 ABS. 2</b> DSGVO HABEN SIE DAS RECHT JEDERZEIT
                WIDERSPRUCH GEGEN DIE VERWENDUNG IHRER PERSONENBEZOGENEN DATEN
                ZUM ZWECKE DER DIREKTWERBUNG EINZULEGEN. DIES GILT AUCH FÜR DAS
                PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG
                STEHT. WIDERSPRECHEN SIE DER VERARBEITUNG FÜR ZWECKE DER
                DIREKTWERBUNG, SO WERDEN WIR IHRE PERSONENBEZOGENEN DATEN NICHT
                MEHR FÜR DIESE ZWECKE VERARBEITEN.
              </p>
              <p>
                <b>EINLEGUNG DES WIDERSPRUCHS</b>: DER WIDERSPRUCH KANN FORMLOS
                PER POST ODER E-MAIL ERKLÄRT WERDEN UND IST AN:
              </p>

              <p>BIMSWARM GmbH</p>
              <p>Geneststraße 5 / Aufgang A</p>
              <p>10829 Berlin</p>
              <p>Deutschland</p>
              <p>TEL. +49 30 92108778 0</p>
              <p>E-MAIL info&#64;bimswarm.de</p>
              <p>ZU RICHTEN.</p>
            </ol>
          </ul>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Bereitstellung">
          <h2>
            10 Besteht eine Pflicht zur Bereitstellung personenbezogener Daten?
          </h2>
          <p>
            Wir machen den Abschluss von Verträgen mit uns nicht davon abhängig,
            dass Sie uns zuvor personenbezogene Daten bereitstellen. Für Sie als
            Nutzer besteht grundsätzlich auch keine gesetzliche oder
            vertragliche Verpflichtung, uns Ihre personenbezogenen Daten zur
            Verfügung zu stellen; es kann jedoch sein, dass wir bestimmte
            Angebote nur eingeschränkt oder gar nicht erbringen können, wenn Sie
            die dafür erforderlichen Daten nicht bereitstellen.
          </p>
        </li>

        <!-- ---------------------------------------------------------------------------------------------------------------------------------->

        <li id="Entscheidungsfindung">
          <h2>
            11 Findet eine automatisierte Entscheidungsfindung (einschließlich
            Profiling) statt?
          </h2>
          <p>
            Wir haben nicht die Absicht, von Ihnen erhobene personenbezogene
            Daten für ein Verfahren zur automatisierten Entscheidungsfindung
            (einschließlich Profiling) zu verwenden.
          </p>
        </li>

        <li id="Schutzmassnahmen">
          <h2>12 Existieren technische Schutzmaßnahmen?</h2>
          <p>
            Wir bedienen uns geeigneter technischer und organisatorischer
            Sicherheitsmaßnahmen, um Ihre personenbezogenen Daten gegen
            zufällige oder vorsätzliche Manipulationen, teilweisen oder
            vollständigen Verlust, Zerstörung oder gegen den unbefugten Zugriff
            Dritter zu schützen unter Berücksichtigung des Stands der Technik,
            der Implementierungskosten und der Natur, des Umfangs, des Kontextes
            und des Zwecks der Verarbeitung sowie der bestehenden Risiken einer
            Datenpanne (inklusive von deren Wahrscheinlichkeit und Auswirkungen)
            für den Betroffenen.
          </p>
          <p>
            Zu den Maßnahmen gehören insbesondere die Sicherung der
            Vertraulichkeit, Integrität und Verfügbarkeit von Daten durch
            Kontrolle des physischen und elektronischen Zugangs zu den Daten als
            auch des sie betreffenden Zugriffs, der Eingabe, der Weitergabe, der
            Sicherung der Verfügbarkeit und ihrer Trennung. Des Weiteren haben
            wir Verfahren eingerichtet, die eine Wahrnehmung von
            Betroffenenrechten, die Löschung von Daten und Reaktionen auf die
            Gefährdung der Daten gewährleisten. Ferner berücksichtigen wir den
            Schutz personenbezogener Daten bereits bei der Entwicklung bzw.
            Auswahl von Hardware, Software sowie Verfahren entsprechend dem
            Prinzip des Datenschutzes, durch Technikgestaltung und durch
            datenschutzfreundliche Voreinstellungen.
          </p>
          <p>
            Sofern IP-Adressen von uns oder von den eingesetzten Dienstleistern
            und Technologien verarbeitet werden und die Verarbeitung einer
            vollständigen IP-Adresse nicht erforderlich ist, wird die IP-Adresse
            gekürzt (auch als "IP-Masking" bezeichnet). Hierbei werden die
            letzten beiden Ziffern, bzw. der letzte Teil der IP-Adresse nach
            einem Punkt entfernt, bzw. durch Platzhalter ersetzt. Mit der
            Kürzung der IP-Adresse soll die Identifizierung einer Person anhand
            ihrer IP-Adresse verhindert oder wesentlich erschwert werden.
          </p>
          <p>
            Um Ihre via unser Online-Angebot übermittelten Daten zu schützen,
            nutzen wir eine SSL-Verschlüsselung. Sie erkennen derart
            verschlüsselte Verbindungen an dem Präfix https:// in der
            Adresszeile Ihres Browsers.
          </p>
          <p>
            Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen
            Entwicklung fortlaufend verbessert. Nähere Informationen hierzu
            erteilen wir Ihnen auf Anfrage gerne.
          </p>
        </li>

        <li id="Stand">
          <h2>13 Stand und Aktualisierung</h2>
          <p>
            Bitte beachten Sie, dass diese Datenschutzerklärung jederzeit von
            uns geändert werden kann, soweit dies erforderlich ist, um Sie
            angemessen über die Verarbeitung Ihrer personenbezogenen Daten zu
            informieren. Bitte prüfen Sie diese Datenschutzerklärung daher in
            regelmäßigen Abständen, soweit Sie unsere Dienstleistungen
            regelmäßig in Anspruch nehmen.
          </p>
          <p>
            Sofern wir in dieser Datenschutzerklärung Adressen und
            Kontaktinformationen von Unternehmen und Organisationen angeben,
            bitten wir zu beachten, dass die Adressen sich über die Zeit ändern
            können und bitten die Angaben vor Kontaktaufnahme zu prüfen.
          </p>
        </li>

        <p><b>Stand: 09.12.2025 </b></p>
      </ol>
    </div>
  </div>
</div>
